
(function(angular, schoolwork12) {
    'use strict';
    
    angular.module(schoolwork12.app.student.name)
        .controller(schoolwork12.app.student.controllers.studentGradPlan, 
        ['$rootScope', '$scope', '$http', '$location', '$uibModal', '$filter', 'graduationPlanSvc', 
        schoolwork12.app.auth.services.authentication,
        schoolwork12.app.common.services.utilService,
        schoolwork12.app.student.services.graduationPlanReqNameSvc,

                function($rootScope, $scope, $http, $location, $uibModal, $filter, graduationPlanSvc, authentication, utilService, graduationPlanReqNameSvc) {
                console.info('calling student grad plan Controller......');
                    $scope.forms = {};
                    $scope.editGradErrorOccurred = false;
                    $scope.stuGradPlanSuccess = false;
                    $scope.toggleMove = false;
                    $scope.toggleSnapshot = false;
                    $scope.priNotesEditing = false;
                    $scope.staNotesEditing = false;
                    $scope.stuNotesEditing = false;
                    $scope.addPrevYearPlanClicked = false;
                    $scope.courseMoved = false;

                    $rootScope.hideStudentSearch = true;
                    $scope.$parent.$parent.hideStudentDetails = true;
                    $scope.$parent.$parent.editErrorOccurred = false;
                    $scope.$parent.$parent.showSavedStudentMsg = false;
                    $scope.$parent.$parent.attInfoErrorOccurred = false;
                    $rootScope.$on('hideStudentDetails', ()=>{
                        if($scope.$parent && $scope.$parent.$parent)
                            $scope.$parent.$parent.hideStudentDetails = true;
                    });

                    $scope.bySubjectView = false;
                    $scope.byYearView = true;
                    $scope.validateYearPlans = false;
                    $scope.validateAddCourses = false;
                    $scope.validateAddRequirements = false;
                    graduationPlanSvc.editSubjectView = false;
                    var flag = false;
                    var date;
                    $scope.gridOptions = {
                        rowHeight: 50,
                        paginationPageSizes : [ 25, 50, 75 ],
                        paginationPageSize : 25,
                        enableFiltering: true,
                        enableGridMenu: true,
                         exporterMenuPdf: false
                    };             
                    $scope.gridOptionsNotes = {
                        rowHeight: 50,
                        paginationPageSizes : [ 25, 50, 75 ],
                        paginationPageSize : 25,
                        enableFiltering: true,
                        enableGridMenu: true,
                         exporterMenuPdf: false
                    };
                    $scope.gridOptions.onRegisterApi = function(gridApi) {
                        $scope.gridApi = gridApi;
                        $scope.resizeGrid = {
                            'width' : 'auto',
                            'margin-left': '300px'
                        };

                        $scope.paginationChanged = false;
                        $scope.currentPageSize = 25;
                        var pageNumber, pageSize;
                        $scope.gridApi.pagination.on.paginationChanged($scope, function (pageNumber, pageSize){  
                            // console.log("paginationChanged")         ;    
                            // console.log(""+pageNumber+"-"+pageSize);              
                            $scope.paginationChanged = true;
                            $scope.currentPageSelection = pageNumber;
                            $scope.currentPageSize = pageSize;
                        }); 
                    };
                    $scope.gridOptionsNotes.onRegisterApi = function(gridApi) {
                        $scope.gridApi = gridApi;
                        $scope.resizeGrid = {
                            'width' : 'auto',
                            'margin-left': '300px'
                        };

                        $scope.paginationChanged = false;
                        $scope.currentPageSize = 25;
                        var pageNumber, pageSize;
                        $scope.gridApi.pagination.on.paginationChanged($scope, function (pageNumber, pageSize){  
                            // console.log("paginationChanged")         ;    
                            // console.log(""+pageNumber+"-"+pageSize);              
                            $scope.paginationChanged = true;
                            $scope.currentPageSelection = pageNumber;
                            $scope.currentPageSize = pageSize;
                        }); 
                    };
                    var sortDateFn = function(a, b) {
                        var nulls = handleNulls(a, b);
                        if (nulls !== null) {
                            return nulls;
                        } else {
                            var aDate = moment(a, "MM DD YYYY");
                            var bDate = moment(b, "MM DD YYYY");
                            if (aDate > bDate) {
                                return 1;
                            } else if (bDate > aDate) {
                                return -1;
                            } else {
                                return 0;
                            }
                        }
                    };
                                        // Sorts nulls and undefined to the bottom (top when descending).  
                    // @returns null if there were no nulls/undefined, otherwise returns
                    // a sort value that should be passed back from the sort function
                    var handleNulls = function(a, b) {
                        // We want to allow zero values and false values to be evaluated in the sort function
                        if ((!a && a !== 0 && a !== false) || (!b && b !== 0 && b !== false)) {
                            // We want to force nulls and such to the bottom when we sort... which effectively is "greater than"
                            if ((!a && a !== 0 && a !== false) && (!b && b !== 0 && b !== false)) {
                                return 0;
                            } else if (!a && a !== 0 && a !== false) {
                                return 1;
                            } else if (!b && b !== 0 && b !== false) {
                                return -1;
                            }
                        }
                        return null;
                    };
                    $scope.gridOptions.columnDefs = [
                        { field: 'eventName', displayName: 'Event Type', width: '27%' },
                        { field: 'status', displayName: 'Status', width: '11%'},
                        { field: 'modifyDate',  sortingAlgorithm: sortDateFn , displayName: 'Modify Date', width: '13%'  },
                        { field: 'modifiedBy', displayName: 'Modified By', width: '15%'},
                        { field: 'description', displayName: 'Description'}
                    ];
                    $scope.gridOptionsNotes.columnDefs = [
                        { field: 'action', displayName: 'Action', width: '13%' },
                        { field: 'type', displayName: 'Type', width: '11%'},
                        { field: 'modifyDate',  sortingAlgorithm: sortDateFn , displayName: 'Modify Date', width: '13%'  },
                        { field: 'creatorName', displayName: 'Modified By', width: '20%'},
                        { field: 'note', displayName: 'Note'},
                    ];
                    
                    $scope.showAuditTrailModal = function(){
                         $scope.auditTrailModalInstance = $uibModal.open({
                            animation: $scope.animationsEnabled,
                            templateUrl: 'auditTrail.html',
                            keyboard: false,
                            scope: $scope,
                            size:'lg',
                            backdrop: 'static',
                            windowClass: 'large-Modal',
                            controller: ['$scope', '$uibModalInstance',
                            function ($scope, $uibModalInstance) {
 
                                $scope.getAuditTrailArchive = function(){
                                    $scope.loadArchiveModalInstance = $uibModal.open({
                                        animation: $scope.animationsEnabled,
                                        templateUrl: 'loadArchive.html',
                                        keyboard: false,
                                        backdrop: 'static',
                                        scope: $scope,
                                        controller: ['$scope', '$uibModalInstance',
                                        function ($scope, $uibModalInstance){
                                            $scope.ok = function(){
                                                $uibModalInstance.close(true);
                                                $scope.gridOptions.data=[];
                                                $scope.modalError = false;
                                                $scope.getAuditTrail(1);
                                            };
                                            $scope.cancel = function(){
                                                $uibModalInstance.dismiss('cancel');
                                            };
                                        }],
                                    });    
                                };
 
                                $scope.getAuditTrail = function(archive){
                                    $scope.isAuditTrailSpinnerActive = true;
                                     $http({
                                        url: schoolwork12.app.student.endpoints.studentEdit + $scope.studentRow.entity.studentId + '/auditTrail/gradplan/' + $scope.gpHeader.studentGradPlanId+ '/schoolId/'+ $scope.studentRow.entity.schoolId+'/archive/' +archive,  
                                        method : "GET",
                                        headers : {
                                                    'X-API-TOKEN': authentication.getCurrentUser().keycode
                                                }
                                    }).then(function(response){       
                                        console.info("Viewing Audit Trail");
                                        if(angular.isDefined(response.data.eATlist)){
                                            $scope.gridOptions.data = response.data.eATlist;
                                        }
                                          $scope.isAuditTrailSpinnerActive = false;
                                    }, function(error){
                                        console.info('Error in Audit Trail...'.concat(angular.toJson(error)));
                                        $scope.modalError = true;
                                        $scope.auditTrailErrorMsg = "";
                                          $scope.isAuditTrailSpinnerActive = false;

                                        if (error.status == 400) {
                                            $scope.stuGradPlanSuccess = false;
                                            for (var j = 0; j < error.data._errors.length; j++) {
                                                $scope.auditTrailErrorMsg = $scope.auditTrailErrorMsg + error.data._errors[j] + "\n";
                                            }
                                        } else if (error.status == 401 || error.status == 403) {
                                            $scope.auditTrailErrorMsg = schoolwork12.app.errorMessages.sessionExpired;
                                        } else {
                                            $scope.auditTrailErrorMsg = schoolwork12.app.errorMessages.internalError;
                                        } 
                                        
                                    })
                                };
 
                                $scope.closeAuditTrail = function () {
                                    $uibModalInstance.close(true);
                                };

                                var archive = 0;
                                $scope.gridOptions.data=[];
                                $scope.modalError = false;
                                $scope.getAuditTrail(0);

                            }], 
                            
                        });
                    }
                    //begin notes audit trail  
                    $scope.showNotesAuditTrailModal = function(){
                         $scope.notesAuditTrailModalInstance = $uibModal.open({
                            animation: $scope.animationsEnabled,
                            templateUrl: 'notesAuditTrail.html',
                            keyboard: false,
                            scope: $scope,
                            size:'lg',
                            backdrop: 'static',
                            windowClass: 'large-Modal',
                            controller: ['$scope', '$uibModalInstance',
                            function ($scope, $uibModalInstance) {
 
                                $scope.getNotesAuditTrailArchive = function(){
                                    $scope.isAuditTrailSpinnerActive = true;
                                    var getNotesAuditTrailPromise = graduationPlanSvc.getAuditTrailSavedNotes(authentication.getCurrentUser().keycode, $scope.gpHeader.studentGradPlanId);
                                    getNotesAuditTrailPromise.then(function (data) {    

                                        console.info("Viewing Notes Audit Trail");
                                        if(angular.isDefined(data.noteList)){
                                            $scope.gridOptionsNotes.data = data.noteList;
                                        }
                                          $scope.isAuditTrailSpinnerActive = false;
                                    }, function(error){
                                        console.info('Error in Notes Audit Trail...'.concat(angular.toJson(error)));
                                        $scope.modalError = true;
                                        $scope.auditTrailErrorMsg = "";
                                          $scope.isAuditTrailSpinnerActive = false;

                                        if (error.status == 400) {
                                            $scope.stuGradPlanSuccess = false;
                                            for (var j = 0; j < error.data._errors.length; j++) {
                                                $scope.auditTrailErrorMsg = $scope.auditTrailErrorMsg + error.data._errors[j] + "\n";
                                            }
                                        } else if (error.status == 401 || error.status == 403) {
                                            $scope.auditTrailErrorMsg = schoolwork12.app.errorMessages.sessionExpired;
                                        } else {
                                            $scope.auditTrailErrorMsg = schoolwork12.app.errorMessages.internalError;
                                        } 
                                        
                                    })
                                };
 
                                
                                $scope.closeNotesAuditTrail = function () {
                                    $uibModalInstance.close(true);
                                };

                                $scope.gridOptionsNotes.data=[];
                                $scope.modalError = false;
                                $scope.getNotesAuditTrailArchive();
                            }], 
                            
                        });
                    }//end notes audit trail  

                    //begin - note functionality
                    $scope.noteOwnerId = authentication.getCurrentUser().identityid; 
                    var rolesArr = authentication.getCurrentUser().roles;
                    var roleName = authentication.getPrimaryRole();
                    var rolesNewArr = schoolwork12.app.primaryRoles;
                  
                    var roleObj = _.find(rolesArr, function (roleObj) { return roleObj._name == roleName; });
                    $scope.roleId = roleObj._roleId;

                    $scope.note = {};
                    //set default views based on role


                    $scope.noteAccessRole = $scope.stuPlanViewRole || $scope.stuPlanEditRole;
                    $scope.byPrivateView = $scope.stuPlanEditRole ? true : false;
                    $scope.byStaffView = !$scope.stuPlanEditRole ? true : false;
                    $scope.togglePrivateView = function(){
                        $scope.byPrivateView = true;
                        $scope.byStaffView = false;
                        $scope.byStudentView = false;
                    }

                    $scope.toggleStaffView = function(){
                        $scope.byPrivateView = false;
                        $scope.byStaffView = true;
                        $scope.byStudentView = false;
                    }

                    $scope.toggleStudentView = function(){
                        $scope.byPrivateView = false;
                        $scope.byStaffView = false;
                        $scope.byStudentView = true;
                    }

                    $scope.cancelNote = function(){
                   	 if($scope.forms.PrivateForm.$dirty || $scope.forms.StaffForm.$dirty || $scope.forms.StudentForm.$dirty){
                   		$scope.openAlertUnsavedNote(); 
                   		$scope.modalInstance3.result.then(function (option) {
                            console.log("cancelNote", option)
                        	if(option){
                        		$scope.hideNote = true;

                                $scope.editNoteStaffErrorOccurred = false;
                                $scope.editNoteStuErrorOccurred = false;

                                $scope.forms.PrivateForm.$setPristine();
                                $scope.forms.StaffForm.$setPristine();
                                $scope.forms.StudentForm.$setPristine();
                            }
                         });
                   	 } else {
                        console.log(" cancel note block")
                        $scope.hideNote = true;
                   	 }
                       
                    }

                   
                    $scope.toggleNote = function(){
                    $scope.showNote = $scope.showNote === false ? true: false;
    
                    $scope.option3 = false;
                    if($scope.forms.PrivateForm){
                        if($scope.forms.PrivateForm.$dirty || $scope.forms.StaffForm.$dirty || $scope.forms.StudentForm.$dirty){
                            if(!$scope.option3){
                                 console.log("note link prompt", $scope.option3);
                                 $scope.toggleNoSelected = true;
                                 $scope.openAlertUnsavedNote(); 
                                 $scope.hideNote = false;
                                 $scope.showNote = true; 
                            }

                            $scope.modalInstance3.result.then(function (option) {
                                $scope.option3 = option;
                                    if(option){
                                        console.log("yes selected", option)
                                        $scope.hideNote = true;
                                        $scope.toggleNoSelected = false;

                                        $scope.editNoteStaffErrorOccurred = false;
                                        $scope.editNoteStuErrorOccurred = false;

                                        $scope.forms.PrivateForm.$setPristine();
                                        $scope.forms.StaffForm.$setPristine();
                                        $scope.forms.StudentForm.$setPristine();
                                    }
                                  
                             });
    
                        }
                    }

                    else {
                         console.log("togglenote else block")
                         $scope.showNote = true;
                         $scope.hideNote = false;

                         if($scope.toggleNoSelected){
                            console.log("inside disable edit")
                            $scope.getSavedNotes();
                         }
                     }

                        if(!$scope.toggleNoSelected){
                            $scope.getSavedNotes();
                        }
                        
                    }

                    $scope.getSavedNotes = function(){
                        $scope.priNotesEditing = false;
                        $scope.staNotesEditing = false;
                        $scope.stuNotesEditing = false;
                        $scope.savedNoteMsg = false;
                        $scope.editNoteStaffErrorOccurred = false;
                        $scope.editNoteStuErrorOccurred = false;

                        //GET saved notes list for student
                        var getSavedNotesPromise = graduationPlanSvc.getSavedNotes(authentication.getCurrentUser().keycode, $scope.gpHeader.studentGradPlanId);
                        getSavedNotesPromise.then(function (data) {    
                            console.info("Providing list of saved notes"); 

                            var noteListArr = $scope.noteList = data.noteList;
                             $scope.noteCount = noteListArr.length;
                            //fetch private/staff/student objects from get svc
                            var priNoteObj = _.find(noteListArr, function (priNoteObj) { return priNoteObj.noteTypeId == 1; });
                            if(priNoteObj){
                                // var priRole = _.find(rolesArr, function (priRole) { return priRole._roleId == priNoteObj.roleId; });
                                var key, obj, priRole;
                                for (key in rolesNewArr) {
                                    obj = rolesNewArr[key];

                                    if(obj == priNoteObj.roleId){
                                       priRole = key.charAt(0).toUpperCase() + key.substr(1);;
                                    }
                                }

                                $scope.priRoleName = priRole ? priRole : '';
                                // console.log("$scope.priRoleName", $scope.priRoleName)
                            }    
                            $scope.privateNoteObj = priNoteObj;
                            $scope.note.privateNote = priNoteObj ? $scope.privateNoteObj.note : '';
                            $scope.priNoteId = priNoteObj ? priNoteObj.id : null;
                            
                            var staNoteObj = _.find(noteListArr, function (staNoteObj) { return staNoteObj.noteTypeId == 2; });
                            if(staNoteObj){
                                // var staRole = _.find(rolesArr, function (staRole) { return staRole._roleId == staNoteObj.roleId; });
                                var key, obj, staRole;
                                for (key in rolesNewArr) {
                                    obj = rolesNewArr[key];

                                    if(obj == staNoteObj.roleId){
                                       staRole = key.charAt(0).toUpperCase() + key.substr(1);;
                                    }
                                }

                                $scope.staRoleName = staRole ? staRole : '';
                                // console.log("$scope.staRoleName", $scope.staRoleName)
                                
                            }    
                                $scope.staffNoteObj = staNoteObj;
                                $scope.note.staffNote = staNoteObj ? $scope.staffNoteObj.note : '';
                                $scope.staNoteId = staNoteObj ? staNoteObj.id : null;
                         
                            var stuNoteObj = _.find(noteListArr, function (stuNoteObj) { return stuNoteObj.noteTypeId == 3; });
                            if(stuNoteObj){
                                // var stuRole = _.find(rolesArr, function (stuRole) { return stuRole._roleId == stuNoteObj.roleId; });
                                var key, obj, stuRole;
                                for (key in rolesNewArr) {
                                    obj = rolesNewArr[key];

                                    if(obj == stuNoteObj.roleId){
                                       stuRole = key.charAt(0).toUpperCase() + key.substr(1);;
                                    }
                                }

                                $scope.stuRoleName = stuRole ? stuRole : '';
                                // console.log("$scope.stuRoleName", $scope.stuRoleName)
                            }    
                                $scope.studentNoteObj = stuNoteObj;
                                $scope.note.studentNote = stuNoteObj ? $scope.studentNoteObj.note : '';
                                $scope.stuNoteId = stuNoteObj ? stuNoteObj.id : null;

                        }, function (error) {
                            console.info('Error in getting saved notes....'.concat(angular.toJson(error)));   
                            if (error.status == 400) {
                                for ( var j = 0; j < error.data._errors.length; j++) {
                                    $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                            }
                        })

                    };

                    $scope.editPrivateNote = function(){
                        console.log("edit private note");
                        $scope.priNotesEditing = true;
                    }

                    $scope.editStaffNotes = function(){
                       console.log("edit staff notes");
                       $scope.staNotesEditing = true;
                    }

                    $scope.editStudentNotes = function(){
                       console.log("edit student notes");
                       $scope.stuNotesEditing = true;
                    }

                    $scope.saveNote = function(){
                        $scope.isSaveNoteBusy = true;
                        $scope.privateNoteCount = $scope.note.privateNote ? 1 : 0;
                        $scope.staffNoteCount = $scope.note.staffNote ? 1 : 0;
                        $scope.studentNoteCount = $scope.note.studentNote ? 1 : 0;

                        var listNoteArr = [];
                        var listNoteObj = {};
                        listNoteArr.push(
                        {
                            "id": null || $scope.priNoteId,
                            "note": $scope.note.privateNote,
                            "ownerId": $scope.noteOwnerId,
                            "roleId": $scope.roleId,
                            "noteTypeId": 1,
                            "status": $scope.privateNoteCount ? 1 : 0
                        }, 
                        {
                            "id": null || $scope.staNoteId,
                            "note": $scope.note.staffNote,
                            "ownerId": $scope.noteOwnerId,
                            "roleId": $scope.roleId,
                            "noteTypeId": 2,
                            "status": $scope.staffNoteCount ? 1 : 0
                        },
                        {
                            "id": null || $scope.stuNoteId,
                            "note": $scope.note.studentNote,
                            "ownerId": $scope.noteOwnerId,
                            "roleId": $scope.roleId,
                            "noteTypeId": 3,
                            "status": $scope.studentNoteCount ? 1 : 0
                        })

                        //initialise json 
                        listNoteObj.listNote = listNoteArr;

                        //check if either type note exists
                        if($scope.forms.PrivateForm.$dirty || $scope.forms.StaffForm.$dirty || $scope.forms.StudentForm.$dirty){
                            var saveGradPlanNotesPromise = graduationPlanSvc.saveGradPlanNotes(authentication.getCurrentUser().keycode, $scope.gpHeader.studentGradPlanId, listNoteObj);
                            saveGradPlanNotesPromise.then(function (data) {
                                $scope.editNoteStaffErrorOccurred = false;
                                $scope.editNoteStuErrorOccurred = false;
                                $scope.noteCount = $scope.privateNoteCount + $scope.staffNoteCount + $scope.studentNoteCount;
                                console.info("Saving grad plan notes"); 
                                $scope.hideNote = true;
                                $scope.isSaveNoteBusy = false;
                                $scope.savedNoteMsg = true;

                                $scope.forms.PrivateForm.$setPristine();
                                $scope.forms.StaffForm.$setPristine();
                                $scope.forms.StudentForm.$setPristine();
                        
                            }, function (error) {
                                console.info('Error in saving gradplan notes....'.concat(angular.toJson(error))); 
                                $scope.isSaveNoteBusy = false;  
                                $scope.savedNoteMsg = false;
                                
                                $scope.editErrorMesg = "";
                                $scope.editNoteErrorMesg = "";
                                $scope.editNoteStaffErrorOccurred = false;
                                $scope.editNoteStuErrorOccurred = false;
                                if (error.status == 400) {
                                    for ( var j = 0; j < error.data._errors.length; j++) {
                                        $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";

                                        var checkErrorMsg = $scope.editErrorMesg;
                                        //display errors based on back end error msgs
                                        if(~checkErrorMsg.indexOf("2 Note")){
                                            $scope.editNoteStaffErrorOccurred = true;
                                            $scope.editNoteErrorMesg = checkErrorMsg.substr(1).slice(0);
                                        } 
                                        if(~checkErrorMsg.indexOf("3 Note")){
                                            $scope.editNoteStuErrorOccurred = true;
                                            $scope.editNoteErrorMesg = checkErrorMsg.substr(1).slice(0);
                                        }

                                        }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }
                            })
                        } 
                    }
                    //end - note functionality

                    $scope.toggleSubjectView = function(){
                    	$scope.bySubjectView = true;
                        $scope.byYearView = false;
                        $scope.showSavedStudentMsg = false; 
                        $scope.yearViewClicked = false;
                        $rootScope.saveBySubjectPlanSuccess = false;
                    }

                    $scope.toggleYearView = function(){
                        $scope.byYearView = true;
                        $scope.bySubjectView = false;
                        $scope.yearViewClicked = true;
                         if($rootScope.saveBySubjectPlanSuccess){
	                        $scope.getStudentGradPlan();
	                        $rootScope.saveBySubjectPlanSuccess=false;
                        }
                   }

                    $scope.disableEditMode = function(){
                          $scope.editMode = false;
                          if (graduationPlanSvc.editSubjectView) graduationPlanSvc.editSubjectView = false;
                    }
                    // changes for Accordion
                    $scope.gradPlanAccordions = { creditViewSummary: true, creditEditSummary: false, additionalCourses: true, addRequirements: true, opened: true };

                    // page refresh redirect to search page    
                    if(!$scope.$parent.studentResultsGridObject){
                        $location.url('/student-search');
                    }

                    var currentStudent = angular.copy($scope.studentRow.entity); 

                    

                 


                    $scope.getRetroChangeIndicator = function(isSave){
                        if  (isSave === 0 && $scope.editMode)
                            return
                        //isSave flag to check is SaveButton was pushed or EditMode
                        $scope.indicator =0 ;  
                        var dateTime = "";
                        if(isSave){
                            // dateTime = $filter('date')($scope.dateParams , 'MM/dd/yyyy HH:mm:ss');
                            dateTime = $scope.dateParams;
                            // console.log("DATE", dateTime)

                        } else {
                            //clicking edit invoke by Suject svc call   
                            if($scope.byYearView){
                                console.log("Getting Grad Plan by Subject view - on edit");
                                $http({
                                    url: schoolwork12.app.student.endpoints.studentEdit + $scope.studentRow.entity.studentId + '/gradplanBySubject/school/' + $scope.studentRow.entity.schoolId,  
                                    method : "GET",
                                    headers : {
                                                'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                            }
                                }).then(function(response){                        
                                    console.info("Viewing student graduation plan by Subject");
                                    $scope.stuGPBySubResponse = response.data.stuGradPlanBySubject;
                                    // console.log("$scope.stuGPBySubResponse", $scope.stuGPBySubResponse)

                                    // build subjectsList
                                    $scope.subjectSnapList = [];
                                    angular.forEach($scope.stuGPBySubResponse.subjectsDetails, function(subject){
                                        subject.subjectName = $scope.subjectNameFromMap(subject.schoolSubjectId, subject.k12SubjectId);
                                        
                                        subject.creditsEarned = angular.isDefined(subject.creditsEarned) ? subject.creditsEarned : 0;
                                        subject.creditsRequired = angular.isDefined(subject.creditsRequired) ? subject.creditsRequired : 0;

                                        if(angular.isDefined(subject.subSubjects)){
                                            angular.forEach(subject.subSubjects, function(subSubject){
                                                subSubject.subjectName = $scope.subjectNameFromMap(subSubject.schoolSubjectId,subSubject.k12SubjectId); 
                                                subSubject.creditsEarned = angular.isDefined(subSubject.creditsEarned) ? subSubject.creditsEarned : 0;
                                                subSubject.creditsRequired = angular.isDefined(subSubject.creditsRequired) ? subSubject.creditsRequired : 0;
                                                subSubject.creditsInprogress = angular.isDefined(subSubject.creditsInprogress) ? subSubject.creditsInprogress : 0;
                                                subSubject.creditsNotStarted = angular.isDefined(subSubject.creditsNotStarted) ? subSubject.creditsNotStarted : 0;
                                                subSubject.creditsNotCounted = angular.isDefined(subSubject.creditsNotCounted) ? subSubject.creditsNotCounted : 0;
                                                angular.forEach(subSubject.stuGPCourse, function(course){
                                                   course.subjectName = subSubject.subjectName;
                                                   course.subject =   subSubject.schoolSubjectId ;
                                                   course.k12SubjectId = subSubject.k12SubjectId ;
                                                   if(course.isNonK12Course == 1){
                                                       course.courseName = course.nonK12CourseName;
                                                   }
                                                   else{
                                                       course.courseName = $scope.courseDisplay(course); 
                                                   }
                                                   
                                                   course.termName = course.gpTermName;
                                                    if(angular.isDefined(course.schoolYear)){
                                                    course.schoolYear = course.schoolYear + " - " +  (course.schoolYear + 1);
                                                    }else{
                                                       course.schoolYear = angular.isDefined(course.additnlCousDisplaySchoolYear) 
                                                                            ? (course.additnlCousDisplaySchoolYear + " - " + (course.additnlCousDisplaySchoolYear + 1)) : "";         
                                                    }

                                                   course.credits = $scope.creditsDisplay(course);
                                                   getGradefromStatus(course);
                                                   course.showDagger = course.doNotIncludeInCreditTotals == 1 || course.subjectNotOnDiploma == 1 ? true : false;
                                                   course.showAstrick = course.completionStatusId == 0 || course.completionStatusId == 1 ? true : false;
                                                });
                                            });
                                        } else {
                                            angular.forEach(subject.stuGPCourse, function(course){
                                                course.subjectName = subject.subjectName;
                                                course.subject =  subject.schoolSubjectId ;
                                                course.k12SubjectId = subject.k12SubjectId ;
                                                if(course.isNonK12Course == 1){ 
                                                    course.courseName = course.nonK12CourseName;
                                                }
                                                else { 
                                                    course.courseName = $scope.courseDisplay(course); 
                                                } 

                                                course.termName = course.gpTermName;
                                                if(angular.isDefined(course.schoolYear)){
                                                    course.schoolYear = course.schoolYear + " - " +  (course.schoolYear + 1);
                                                }else{
                                                   course.schoolYear = angular.isDefined(course.additnlCousDisplaySchoolYear) 
                                                                        ? (course.additnlCousDisplaySchoolYear + " - " + (course.additnlCousDisplaySchoolYear + 1)) : "";         
                                                }

                                                course.credits = $scope.creditsDisplay(course);
                                                getGradefromStatus(course);
                                                course.showDagger = course.doNotIncludeInCreditTotals == 1 || course.subjectNotOnDiploma == 1 ? true : false;
                                                course.showAstrick = course.completionStatusId == 0 || course.completionStatusId == 1 ? true : false;

                                            }); 
                                        }
                                        $scope.subjectSnapList.push(subject);
                                        // console.log("$scope.subjectSnapList", $scope.subjectSnapList)
                                        
                                      })

                                        //Sort the hierarchial structure for subjectlist
                                        // For each subject in subject list 
                                        angular.forEach($scope.subjectSnapList, function(subject){                            
                                            // If subsubjects are present                           
                                            if(angular.isDefined(subject.subSubjects)){                                
                                                angular.forEach(subject.subSubjects , function(subSubject){
                                                   //sort courses for each sub-subject
                                                   if(angular.isDefined(subSubject.stuGPCourse && subSubject.stuGPCourse.length > 1)){
                                                        subSubject.stuGPCourse.sort(courseSort);    
                                                   } 
                                                });
                                                //sort sub-subjects alphabetically in each subject
                                                subject.subSubjects.sort(sortSubject);
                                            // If no sub-subjects are present and subject has courses                                
                                            } else if(angular.isDefined(subject.stuGPCourse)){
                                                //sort courses in subject
                                                subject.stuGPCourse.sort(courseSort);
                                            }                           
                                        });
                                        // sort list of subjects alphabetically in subject list
                                        // sample using _.js
                                        $scope.subjectSnapList = _.sortBy($scope.subjectSnapList, 'subjectName');
                                       
                                }, function(error){
                                    console.info('Error in viewing student graduation plan by Subject on Edit...'.concat(angular.toJson(error)));  
                                })
                            }

                        }

                        $http({
                            url: schoolwork12.app.student.endpoints.studentEdit + $scope.studentRow.entity.studentId + '/retro/gradplan/' + $scope.gpHeader.studentGradPlanId+ '/schoolId/'+ $scope.studentRow.entity.schoolId ,  
                            method : "GET",
                            headers : {
                                        'X-API-TOKEN': authentication.getCurrentUser().keycode
                                    },
                            params: {
                                        isSave : isSave,
                                        dateTime : dateTime
                                    }
                        }).then(function(response){       
                            console.info("Retro Change Indicator");
                            $scope.indicator = response.data;
                            retroAction();                                
                        }, function(error){
                            console.info('Error getting Retro Change Indicator...'.concat(angular.toJson(error)));
                             $scope.editGradErrorOccurred = true;
                             $scope.editErrorMesg = "";

                            if (error.status == 400) {
                                $scope.stuGradPlanSuccess = false;
                                for (var j = 0; j < error.data._errors.length; j++) {
                                    $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                            } 
                            
                        });
                                               
                    }

                    var getGradefromStatus = function(course){
                        if(course.completionStatusId==0)
                            course.gradeMark = 'Not Started';
                        if(course.completionStatusId==1)
                            course.gradeMark = 'In Progress';
                         return course.gradeMark;
                    }

                    var sortSubject = function(a, b) {
                        if((a.subjectName == "" || b.subjectName == "") && !(a.subjectName == ""&&b.subjectName == "")){
                            if(a.subjectName=="")
                                return 1;
                            else 
                                return -1;
                        }
                        if(a.subjectName == b.subjectName){
                            return courseSort(a,b);
                        }
                        if(a.subjectName > b.subjectName){
                            return 1;
                        }
                        if(a.subjectName < b.subjectName){
                            return -1;
                        }
                    }
                    
                    var courseSort = function(a, b) {                       
                        if(a.courseName == "Not Specified" || b.courseName == "Not Specified"){                                                   if(a.courseName == "Not Specified") return 1;
                            else return -1;
                        }
                        else{
                            return a.courseName > b.courseName ? 1 : -1;
                        }                        
                    }

                    var retroAction  = function(){
                        if($scope.indicator > 0){
                            if($scope.editMode) saveGradPlan();//if user is in edit mode and pushes save buttton
                            else {
                                console.log("Show modal");
                                $scope.retroIndicator = $uibModal.open({
                                animation: $scope.animationsEnabled,
                                templateUrl: 'retroIndicator.html',
                                keyboard: false,
                                backdrop: 'static',
                                scope: $scope,
                                size:'lg',
                                controller: ['$scope', '$uibModalInstance',
                                function ($scope, $uibModalInstance) {
         
                                        $scope.return = function () {
                                            $uibModalInstance.close(true);


                                        };
                                    //STT-7909 dont allow editing if changes are in progress
                                       /* $scope.continue = function () {
                                            
                                            $uibModalInstance.close(true);
                                            $scope.toggleMode();
                                        }*/

                                        $scope.getAuditTrailFromRetro = function (){
                                            $uibModalInstance.close(true);
                                            $scope.showAuditTrailModal();
                                        };

                                    }], 
                                    
                                });
                             }
                        }else {
                            if(!$scope.editMode)
                                 $scope.toggleMode();
                             else $scope.saveGradPlanEdit();
                        }    
                    }

                    var openAlertRetroChanges = function(){
                         $scope.saveRetroIndicator = $uibModal.open({
                            animation: $scope.animationsEnabled,
                            templateUrl: 'saveRetroIndicator.html',
                            keyboard: false,
                            backdrop: 'static',
                            scope: $scope,
                            size:'lg',
                            controller: ['$scope', '$uibModalInstance',
                            function ($scope, $uibModalInstance) {
     
                                    $scope.return = function () {
                                        $uibModalInstance.close(1);


                                    };
                                    //STT-7909 dont allow editing if changes are in progress
                                   /* $scope.continue = function () {
                                        
                                        $uibModalInstance.close(2);
                                    };*/

                                    $scope.getAuditTrailFromRetro = function (){
                                        $uibModalInstance.close(3);
                                        $scope.showAuditTrailModal();
                                    };

                                }], 
                                
                            });
                    }

                    var saveGradPlan = function(){
                         $scope.showSavedStudentMsg = false;
                            openAlertRetroChanges(); 
                            $scope.saveRetroIndicator.result.then(function (option) {
                                if(option==1){//return to view
                                    if($scope.forms.yearPlans.$dirty || $scope.forms.AdditionalCourses.$dirty || $scope.forms.AdditionalRequirements.$dirty
                                        || $scope.forms.ReadyForStudentView.$dirty || $scope.forms.postHSYear.$dirty){
                                        console.log("Return to view");
                                        angular.copy($scope.yearPlanSnapShot, $scope.yearPlans); 
                                        angular.copy($scope.addCourseSnapShot, $scope.additionalCourseList);
                                        angular.copy($scope.addReqSnapShot, $scope.additionalRequirementList);
                                        angular.copy($scope.readyForStudentViewDisplaySnapShot, $scope.readyForStudentViewDisplay);
                                        $scope.postHSYearDataSnap = {...$scope.postHSYearData};
                                        $scope.editMode = false;
                                         if (graduationPlanSvc.editSubjectView ) graduationPlanSvc.editSubjectView = false;
                                        initializeFormValidations();
                                        resetBeforeSaveValidations();
                                        $scope.forms.yearPlans.$setPristine();
                                        $scope.forms.AdditionalCourses.$setPristine();
                                        $scope.forms.AdditionalRequirements.$setPristine();
                                        $scope.forms.ReadyForStudentView.$setPristine();
                                        $scope.forms.postHSYear.$setPristine();
                                    } 
                                    $scope.editMode = false;//for snapshot without setting form dirty 

                                }/*else if(option==2){//save grad plan
                                       $scope.saveGradPlanEdit();
                                }*/  //STT-7909 dont allow editing if changes are in progress

                            });
                                       
                    }

                    $scope.toggleMode = function() {
                        //<!--alert dialog for leaving page without saving
                        console.log("toggleMode");
                        $scope.option1 = false;
                        $scope.option2 = false;

                        $scope.modalInstance1 = null;
                        $scope.editMode = true;
                        $scope.toggleMove = false;
                        $scope.toggleSnapshot = false;

                        moment.tz.link([
                            'America/New_York|US/Eastern'
                        ]);

                        date = new Date();
                        var formattedDate = moment.tz(date , "America/New_York");
                        $scope.dateParams = formattedDate.format('MM/DD/YYYY HH:mm:ss');
                        // console.log("dateParams", $scope.dateParams)
                        
                        graduationPlanSvc.date = $scope.dateParams;
                        if($scope.bySubjectView)  {
                            $scope.byYearView = false;
                             graduationPlanSvc.editSubjectView = true;
                             $scope.getSchoolSubjects(true);
                        }
                        else {
                            $scope.byYearView = true;
                             graduationPlanSvc.editSubjectView = false;
                             flag = true;
                             $scope.getStudentGradPlan();
                        } 
                        
                        //reset Maps for delete and remove
                        $scope.courseMovedMap = {};
                        $scope.termRemovedMap = {};
                        $scope.courseRemovedMap = {};
                        $scope.yearRemovedList = [];

                        resetBeforeSaveValidations();
                        $scope.forms.yearPlans.$setPristine();
                        $scope.forms.AdditionalCourses.$setPristine();
                        $scope.forms.AdditionalRequirements.$setPristine();
                        $scope.forms.ReadyForStudentView.$setPristine();
                        $scope.forms.postHSYear.$setPristine();


                        $scope.showMovedCoursesMsg = false;
                        $scope.isEditGradPlanSpinnerActive = true;  
                        $scope.selCourseCount = 0;
                     //   $scope.getSchoolSubjects(true);

                    }

                    //close success msg on click
                    $scope.closeStudentMsg = function() {
                        $scope.showSavedStudentMsg = false;
                    }
                    $scope.closeMoveCourseMsg = function() {
                        $scope.showMovedCoursesMsg = false;
                    }
                    $scope.closeSaveSuccessMsg = function(){
                        $scope.savedNoteMsg = false;
                    }

                    $rootScope.$on('$stateChangeStart', function(event, next, current) { 
                      // $scope.searchTab = false;  
                      $scope.stuGradPlanEdited = false;
                        if($scope.forms.yearPlans){ 
                            if($scope.forms.yearPlans.$dirty || $scope.forms.AdditionalCourses.$dirty || $scope.forms.AdditionalRequirements.$dirty
                            		|| $scope.forms.ReadyForStudentView.$dirty || $scope.forms.postHSYear.$dirty){
                                $scope.stuGradPlanEdited = true;

                                if(!$scope.option1){
                                    $scope.openAlertUnsaved();
                                    event.preventDefault(); 
                                }                               
                                
                                $scope.modalInstance1.result.then(function (option) {
                                    $scope.option1 = option;
                                    if((next.url == '/student-details') && $scope.stuGradPlanEdited) { 
                                        $scope.$parent.$parent.hideStudentDetails = false;
                                        $rootScope.hideStudentSearch = true;

                                        //get current student entity row : gradplan edited                                      
                                        $scope.getStudentInfo();
                                        $location.url('/student-search/student-details');
                                        
                                    } else if(next.url == '/student-graduation-plan'){
                                        $location.url('/student-search/student-details/student-graduation-plan');
                                        $rootScope.hideStudentSearch = true;
                                        $scope.getStudentGradPlan();
                                        $scope.toggleYearView();
                                    } else if(next.url == '/cre-tracking'){
                                        $location.url('/student-search/student-details/cre-tracking');
                                    }
                                    else{
                                        $location.url(next.url); 
                                    }
                                });
                            }
                        } 
    
                        if((next.url == '/student-details') && !$scope.stuGradPlanEdited){
                            $scope.$parent.$parent.hideStudentDetails = false;
                            $rootScope.hideStudentSearch = true;

                            //get current student entity row : gradplan not edited  
                            if($scope.gradPlanState && !$scope.isSaveStuPlanBusy){
                                if(!$scope.searchRevisited){
                                    $scope.getStudentInfo();
                                }
                               
                            }                            
                        }
                        
            
                        if(!$scope.hideNote && $scope.forms.PrivateForm && $scope.forms.StaffForm && $scope.forms.StudentForm){
                        	var isNoteEdited =false;
                        	if ($scope.forms.PrivateForm.$dirty || $scope.forms.StaffForm.$dirty || $scope.forms.StudentForm.$dirty)
                        		{
                        		isNoteEdited = true;
                        		}
                            if($scope.forms.PrivateForm.$dirty || $scope.forms.StaffForm.$dirty || $scope.forms.StudentForm.$dirty){
                                $scope.openAlertUnsavedNote(); 
                                event.preventDefault();
                                $scope.hideNote = false;
                                }
                            
                            $scope.modalInstance3.result.then(function (option) {
                                $scope.option3 = option;
                                if(option){
                                    $scope.editNoteStaffErrorOccurred = false;
                                    $scope.editNoteStuErrorOccurred = false;

                                    $scope.forms.PrivateForm.$setPristine();
                                    $scope.forms.StaffForm.$setPristine();
                                    $scope.forms.StudentForm.$setPristine();
                                }

                                if((next.url == '/student-details') && !$scope.isNoteEdited) { 
                                    $scope.$parent.$parent.hideStudentDetails = false;
                                    $rootScope.hideStudentSearch = true;
                                    $scope.hideNote = true;

                                    //get current student entity row : gradplan edited                                      
                                    $scope.getStudentInfo();
                                    $location.url('/student-search/student-details');
                                    
                                } else if(next.url == '/student-graduation-plan'){
                                    $location.url('/student-search/student-details/student-graduation-plan');
                                    $rootScope.hideStudentSearch = true;
                                    $scope.hideNote = true;
                                    $scope.getStudentGradPlan();
                                
                                } else if(next.url == '/cre-tracking'){
                                    $location.url('/student-search/student-details/cre-tracking');
                                }
                                else{
                                    $scope.hideNote = true;
                                    $location.url(next.url); 
                                }
                            });
	                       }
                            
                    })

                    //show unsaved dialog when leaving page when edits have been made
                    $scope.openAlertUnsaved = function () {
                        $scope.modalInstance1 = $uibModal.open({
                            animation: $scope.animationsEnabled,
                            templateUrl: 'commonDialog.html',
                            keyboard: false,
                            backdrop: 'static',
                            windowClass: 'alert-Modal',
                            scope: $scope,
                            controller: ['$scope', '$uibModalInstance',
                            function ($scope, $uibModalInstance) {
                                $scope.ok = function () {
                                    $uibModalInstance.close(true);
                                    $scope.postHSYearData = {...$scope.postHSYearDataSnap};
                                    $scope.disableEditMode();
                                };
                                $scope.dialogMsg = 'You have un-saved changes for the current student. Do you want to continue without saving the changes?';
                                $scope.cancel = function () {
                                    $uibModalInstance.dismiss('cancel');
                                    $rootScope.hideStudentSearch = true;
                                    //if no option is selected from modal
                                    if(!$scope.studentedited){
                                        var index=-1;
                                        for(var i=0; i< $scope.gridNewOptions.data.length; i++){
                                            if($scope.gridNewOptions.data[i].studentId==currentStudent.studentId){
                                                index=i;
                                                $scope.gridNewApi.selection.selectRow($scope.gridNewOptions.data[i]);
                                                break;
                                            }
                                        }
                                    }
                                };
                            }], 
                            
                        });
                        $scope.$parent.$parent.hideStudentDetails = true;
                    };
                    
                    $scope.openAlertUnsavedNote = function () {
                        $scope.modalInstance3 = $uibModal.open({
                            animation: $scope.animationsEnabled,
                            templateUrl: 'commonDialog.html',
                            keyboard: false,
                            backdrop: 'static',
                            windowClass: 'alert-Modal',
                            scope: $scope,
                            controller: ['$scope', '$uibModalInstance',
                            function ($scope, $uibModalInstance) {
                                $scope.ok = function () {
    								$uibModalInstance.close(true);
                                };
                                $scope.dialogMsg = 'You have unsaved changes for the current screen. Do you want to continue without saving the changes?';
                                $scope.cancel = function () {
                                    $uibModalInstance.dismiss('cancel');
                                    console.log("no selected");
                                };
                            }], 
                            
                        });
                    };


                    //show dialog while removing terms
                    $scope.removeTermflag = 0; //0--remove term without course , 1--remove term with not started course
                    $scope.openAlertRemoveTerm = function(){
                        $scope.modalInstance2 = $uibModal.open({
                            animation: $scope.animationsEnabled,
                            templateUrl: 'commonDialog.html',
                            keyboard: false,
                            backdrop: 'static',
                            windowClass: 'alert-Modal',
                            scope: $scope,
                            controller: ['$scope', '$uibModalInstance',
                            function ($scope, $uibModalInstance) {
                                $scope.ok = function () {
                                    $uibModalInstance.close(true);
                                };
                                if($scope.removeTermflag == 0)
                                    $scope.dialogMsg = "You are about to remove a Term from the student's Graduation Plan? Do you want to continue?";
                                else if($scope.removeTermflag == 1)
                                    $scope.dialogMsg = "You are about to remove a Term, along with its planned courses, from the student's Graduation Plan? Do you want to continue?";
                                
                                $scope.cancel = function () {
                                    $uibModalInstance.close(false);
                                };
                            }], 
                            
                        });
                    }
                    //-->
                    
                    //sorting logic for subject&course list
                    var sortSubjectCourse = function(a, b) {
                        if((a.subjectName == "" || b.subjectName == "") && !(a.subjectName == ""&&b.subjectName == "")){
                            if(a.subjectName=="")
                                return 1;
                            else 
                                return -1;
                        }
                        if(a.subjectName == b.subjectName){
                            if(a.courseName == "Not Specified" || b.courseName == "Not Specified"){
                                if(a.courseName == "Not Specified") return 1;
                                else return -1;
                            }
                            else{
                                return a.courseName > b.courseName ? 1 : -1;
                            }
                        }
                        if(a.subjectName > b.subjectName){
                            return 1;
                        }
                        if(a.subjectName < b.subjectName){
                            return -1;
                        }
                    }
                    
                    var sortCourseName = function(a, b) {
                        if(angular.isUndefined(a.name))
                            return -1;
                        if(angular.isUndefined(b.name))
                            return 1;
                        if(b.name == "Non K12 Course")
                            return -1;
                        return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
                    }
                    
                    
                    //subjectMap courseMap
                    $scope.subjectMap = {};
                    $scope.courseMap = {};
                    
                    //build year plan's course
                    $scope.initialiseYearPlanCourse = function(courseObj, course)
                    {
                        courseObj.id = course.id;
                        courseObj.courseName = $scope.courseDisplay(course);
                        courseObj.course = courseFromMap(course.schoolSubjectId, course.k12SubjectId, course.courseId);                            
                        courseObj.subjectName = $scope.subjectNameFromMap(course.schoolSubjectId, course.k12SubjectId);    
                        courseObj.subject = subjectFromMap(course.schoolSubjectId, course.k12SubjectId);               
                        courseObj.completionStatusId = course.completionStatusId;
                        courseObj.grade = course.gradeMark;
                        courseObj.credits = $scope.creditsDisplay(course);
                        courseObj.creditsEarned = course.creditsEarned;
                        courseObj.dualCredit=course.dualCredit;
                        courseObj.tranTermType = course.tranTermType;
                        courseObj.showDagger = 
                            course.doNotIncludeInCreditTotals == 1 || course.subjectNotOnDiploma == 1 ? true : false;
                        courseObj.showAstrick = 
                            course.completionStatusId == 0 || course.completionStatusId == 1 ? true : false;
                        courseObj.doNotIncludeInCreditTotals = course.doNotIncludeInCreditTotals;
                        courseObj.subjectNotOnDiploma = course.subjectNotOnDiploma;
                        courseObj.coursechecked = course.coursechecked;
                        courseObj.isNonK12Course = course.isNonK12Course;
                        courseObj.nonK12CourseName = course.nonK12CourseName;
                        
                        var preCourse = courseObj.course;
                        if(angular.isUndefined(courseObj.allcourses)){
                            courseObj.allcourses = [];
                            if(angular.isDefined(courseObj.subject.courses))
                                angular.extend(courseObj.allcourses,
                                          courseObj.subject.courses);
                        }
                        if(preCourse!=null && angular.isUndefined(preCourse.id) 
                           && $scope.courseDisplay(course)!="Not Specified"
                           && angular.isDefined(courseObj.allcourses)
                           && course.isNonK12Course == 0){
                            preCourse = {id: course.courseId, name: $scope.courseDisplay(course), credits:$scope.creditsDisplay(course)};
                            courseObj.allcourses.push(preCourse);
                            courseObj.allcourses.sort(sortCourseName);
                            courseObj.course = preCourse;
                            
                                            
                        }
                        
                        if(preCourse!=null && angular.isUndefined(preCourse.id) && course.isNonK12Course == 1)
                    	{
	                        var nonK12Course = {id: course.courseId, name: "Non K12 Course", credits:$scope.creditsDisplay(course), nonK12CourseName:course.nonK12CourseName, isNonK12Course:"Yes"};
	                        courseObj.allcourses.sort(sortCourseName);
	                        courseObj.allcourses.push(nonK12Course);
	                       courseObj.course = nonK12Course;
	                    	
                    	}
                        else
                    	{
                        	courseObj.allcourses.sort(sortCourseName);
                        	var nonK12Course =  {id: null,  name: "Non K12 Course", credits:0, nonK12CourseName: "", isNonK12Course:"Yes"};
                            courseObj.allcourses.push(nonK12Course);
                        }
                        
                      }


                    //build logic for tems and years placeholders
                    $scope.getStudentGradPlanDetails = function(){
                        initializeFormValidations();
                        $scope.yearPlans = [];
                        //sort years based on school year
                        $scope.yearDetailList = $scope.yearDetailList.sort(function(a, b) {
                            return a.schoolYear > b.schoolYear ? 1 : -1;
                        });

                        angular.forEach($scope.yearDetailList, function(yearDetails, index1){
                            //reference yearPlans values
                            $scope.yearPlans.push({yearName: '', index: index1, terms:[]});
                            
                            $scope.yearPlans[index1].yearName=yearDetails.yearName;
                            $scope.yearPlans[index1].schoolYear="(" + yearDetails.schoolYear + " - " + (yearDetails.schoolYear + 1) + ")";
                            //$scope.yearPlans[index1].schoolYear= yearDetails.schoolYear;
                            $scope.yearPlans[index1].schoolYearNum = yearDetails.schoolYear;
                            $scope.yearPlans[index1].stuPlanYearId=yearDetails.yearId;
                            $scope.yearPlans[index1].open=true;

                            $scope.yearPlans[index1].totalCreditsEarned=yearDetails.totalCreditsEarned;
                            $scope.yearPlans[index1].totalCreditsInProgress=yearDetails.totalCreditsInProgress;
                            $scope.yearPlans[index1].totalCreditsNotStarted=yearDetails.totalCreditsNotStarted;
                            $scope.yearPlans[index1].totalCreditsDoNotIncludeTowardDiploma=yearDetails.totalCreditsDoNotIncludeTowardDiploma;

                            //sort terms based on sequence
                            yearDetails.stdDbGplanTermList = yearDetails.stdDbGplanTermList.sort(function(a, b) {
                                if(angular.isUndefined(a.sequence))
                                    return -1;
                                if(angular.isUndefined(b.sequence))
                                    return 1;
                                return a.sequence > b.sequence ? 1 : -1;
                            });
                            
                            $scope.yearPlans[index1].additionalTerms = {courses:[]};  
                            angular.forEach(yearDetails.stdDbGplanTermList, function(term, index2){
                             
                                //additional terms with no terms info
                                if(angular.isUndefined(term.termId)){  
                                    angular.forEach(term.stDbGplanCourseList, function(course, index3){
                                        $scope.yearPlans[index1].additionalTerms.courses.push({});
                                        var length = $scope.yearPlans[index1].additionalTerms.courses.length;
                                        $scope.initialiseYearPlanCourse($scope.yearPlans[index1].additionalTerms.courses[length-1], course);
                                    });
                                    
                                    $scope.yearPlans[index1].additionalTerms.courses.sort(sortSubjectCourse);
                                } 
                                //normal terms with terms info
                                else{ 
                                    $scope.yearPlans[index1].terms.push({termName: term.termName, termId: term.termId, courses: [], sequence: parseInt(term.sequence)});
                                    var length = $scope.yearPlans[index1].terms.length;
                                    
                                    angular.forEach(term.stDbGplanCourseList, function(course, index3){
                                        $scope.yearPlans[index1].terms[length-1].courses.push({});
                                        $scope.initialiseYearPlanCourse($scope.yearPlans[index1].terms[length-1].courses[index3], course);
                                    });
                                    
                                    $scope.yearPlans[index1].terms[length-1].courses.sort(sortSubjectCourse);
                                }   
                            });
                        });
                            
                        // create yearPlanSnapShot with index, status
                        for(var i=0; i<$scope.yearPlans.length; i++){
                            $scope.yearPlans[i].index = i;
                            $scope.yearPlans[i].status = 1;
                            if(angular.isDefined($scope.yearPlans[i].terms)){
                                for(var j=0; j<$scope.yearPlans[i].terms.length; j++){
                                    $scope.yearPlans[i].terms[j].index = j;
                                    $scope.yearPlans[i].terms[j].status = 1;
                                    for(var k=0; k<$scope.yearPlans[i].terms[j].courses.length; k++){
                                        $scope.yearPlans[i].terms[j].courses[k].index = k;
                                        $scope.yearPlans[i].terms[j].courses[k].status = 1;
                                    }
                                }
                            }
                            for(var j=0; j<$scope.yearPlans[i].additionalTerms.courses.length; j++){
                                $scope.yearPlans[i].additionalTerms.courses[j].index = j;
                                $scope.yearPlans[i].additionalTerms.courses[j].status = 1;
                            }
                        }
                        
                        $scope.yearPlanSnapShot = [];
                        angular.copy($scope.yearPlans, $scope.yearPlanSnapShot);
                        
                        $scope.additionalCourseList = [];
                        angular.forEach($scope.addCoursesList.stdDbGplanTermList, function(termList, index1){
                          	var res = {};
                          	angular.forEach(termList.stDbGplanCourseList, function(stuGPCourse, index2){
                          		res.index = index2;
                          		res.termId = termList.termId;
	                            res.termName = termList.termName;
	                            res.subjectName = $scope.subjectNameFromMap(stuGPCourse.schoolSubjectId, stuGPCourse.k12SubjectId);
                                res.subject = subjectFromMap(stuGPCourse.schoolSubjectId, stuGPCourse.k12SubjectId);
	                            res.courseName = $scope.courseDisplay(stuGPCourse);
                                res.course = courseFromMap(stuGPCourse.schoolSubjectId, stuGPCourse.k12SubjectId, stuGPCourse.courseId);
                                res.courseId = stuGPCourse.courseId;
	                            if(angular.isDefined(stuGPCourse.schoolYear)){
	                        	   res.schoolYear = stuGPCourse.schoolYear + " - " +  (stuGPCourse.schoolYear + 1);
	                            }else{
	                        	   res.schoolYear = angular.isDefined(stuGPCourse.additnlCousDisplaySchoolYear) 
	                        	   						? (stuGPCourse.additnlCousDisplaySchoolYear + " - " + (stuGPCourse.additnlCousDisplaySchoolYear + 1)) : "";		   	
	                            }
	                           res.grade = stuGPCourse.gradeMark;
  	  	                       res.completionStatusId=stuGPCourse.completionStatusId;
  	  	                       res.credits = $scope.creditsDisplay(stuGPCourse);
	                           res.dualCredit = stuGPCourse.dualCredit;
	                           res.tranTermType = stuGPCourse.tranTermType;
	                           res.showDagger = stuGPCourse.doNotIncludeInCreditTotals == 1 || stuGPCourse.subjectNotOnDiploma == 1 ? true : false;
	                           res.showAstrick = stuGPCourse.completionStatusId == 0 || stuGPCourse.completionStatusId == 1 ? true : false;
                               res.coursechecked = stuGPCourse.coursechecked;
                               //SIS-405 . Set donotIncludeInCreditTotals flag for courses in additional courses
                               res.doNotIncludeInCreditTotals = stuGPCourse.doNotIncludeInCreditTotals;
                               res.subjectNotOnDiploma = stuGPCourse.subjectNotOnDiploma;
                               res.id = stuGPCourse.id;
                               
                               // SIS -303 amd 314 -- If subject is changed in additional course list and saved,
                               // When you come back to additional courses section, on new edit course object is not assigned 
                               // as it now belongs to different subject
                               //If course id in retrieved listis defined and not null then assgn that course object
                               var selectedCourse = res.course;
                               if(selectedCourse != null && angular.isUndefined(selectedCourse.id)){
                                   if(angular.isDefined(res.courseId) && res.courseId != null){
                                       selectedCourse = {id: res.courseId, name: $scope.courseDisplay(stuGPCourse), credits:$scope.creditsDisplay(stuGPCourse)}; 
                                       res.course = selectedCourse;
                                   }
                               }
                               $scope.additionalCourseList.push(res);
                          	});
                          	//sort
                            $scope.additionalCourseList.sort(sortSubjectCourse);
                            
                            // create additionalCoursesSnapShot with index, status  
                            for(var i=0; i<$scope.additionalCourseList.length; i++){
                                $scope.additionalCourseList[i].index = i;
                                $scope.additionalCourseList[i].status = 1;
                            }
                          	
                        });
                        
                        $scope.additionalRequirementList = [];
                        if($scope.addRequirementList != null && angular.isDefined($scope.addRequirementList)){
                        	$scope.addReqStatusMap =additionalReqStatusMap();
                        	angular.forEach($scope.addRequirementList, function(addReq, index1){
                              	var res = {};
                              	res.index = index1;
                              	res.id = addReq.id;
                              	res.category = addReq.gpARCategory;
                              	res.name = addReq.name;
                              	res.comments = addReq.comments;
                              	res.required = (addReq.required == 0)? "No" : "Yes";
                              	res.requiredEdit = addReq.required;
                              	res.completionStatus = additionalReqValueFromMap(addReq.completionStatusId);
                                $scope.additionalRequirementList.push(res);
                              	//sort additional requirements in category order
                                $scope.additionalRequirementList = $scope.additionalRequirementList.sort(function(a, b) {
                                  return a.category > b.category ? 1 : -1;
                                });
                            });
                       }
                        
                       $scope.readyForStudentViewDisplay = {
                    		   valueView : ($scope.readyForStudentView ? 'Yes' :'No'),
                    		   valueEdit : $scope.readyForStudentView
                       }                  
                                       
                        $scope.addCourseSnapShot = [];
                        angular.copy($scope.additionalCourseList, $scope.addCourseSnapShot);
                        $scope.yearPlanSnapShot = [];
                        angular.copy($scope.yearPlans, $scope.yearPlanSnapShot);
                        //console.log('$scope.addCourseSnapShot', $scope.addCourseSnapShot);
                        $scope.addReqSnapShot = [];
                        angular.copy($scope.additionalRequirementList, $scope.addReqSnapShot);
                        $scope.readyForStudentViewDisplaySnapShot = {};
                        angular.copy($scope.readyForStudentViewDisplay, $scope.readyForStudentViewDisplaySnapShot);
                    }


                    $scope.cancelGradPlanEdit = function(){
                        $scope.showSavedStudentMsg = false;
                        $scope.toggleMove = false;
                        $scope.toggleSnapshot = false;
                        //check if form is dirty
                        if($scope.forms.yearPlans.$dirty || $scope.forms.AdditionalCourses.$dirty || $scope.forms.AdditionalRequirements.$dirty
                          || $scope.forms.ReadyForStudentView.$dirty || $scope.forms.postHSYear.$dirty){
                            if(!$scope.option1){
                                $scope.openAlertUnsaved();
                            }                               
                            $scope.modalInstance1.result.then(function (option) {
                                $scope.option1 = option;
                                $scope.editMode = option ? false : true;
								if(option){
                                    angular.copy($scope.yearPlanSnapShot, $scope.yearPlans); 
                                    angular.copy($scope.addCourseSnapShot, $scope.additionalCourseList);
                                    angular.copy($scope.addReqSnapShot, $scope.additionalRequirementList);
                                    angular.copy($scope.readyForStudentViewDisplaySnapShot, $scope.readyForStudentViewDisplay);
                                    $scope.postHSYearData = {...$scope.postHSYearDataSnap};
                                     if (graduationPlanSvc.editSubjectView ) graduationPlanSvc.editSubjectView = false;
                                    initializeFormValidations();
                                }
                            });
                        } else {
                        //disable editing on cancel
                            $scope.editMode = false;
                            if (graduationPlanSvc.editSubjectView ) graduationPlanSvc.editSubjectView = false;
                        }
                    }



                    // get student graduation plan service
                        $scope.getStudentGradPlan = function(){
                            $rootScope.hideStudentSearch = true;
                            $scope.showSavedStudentMsg = false;
                            $scope.isStuGradPlanSpinnerActive = true;
                            $scope.editStudent = angular.copy($scope.studentRow.entity);
                            $http({
                                url: schoolwork12.app.student.endpoints.studentEdit + $scope.studentRow.entity.studentId + '/gradplan/school/' + $scope.studentRow.entity.schoolId,  
                                method : "GET",
                                headers : {
                                            'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                        }
                            }).then(function(response){                   
                                console.info("Viewing student graduation plan");
                                $scope.stuGradPlanSuccess = true;
                                $scope.editGradErrorOccurred = false;
                                $scope.isStuGradPlanSpinnerActive = false;
                                $scope.toggleMove = false;
                                $scope.toggleSnapshot = false;
            
                                $scope.editStudent = angular.extend($scope.editStudent, response.data.studentGradPlan, $scope.gridNewOptions.data);
                                // console.log ("editStudent",$scope.editStudent);
                                $scope.yearDetailList = response.data.studentGradPlan.stdDbGplanYearList;
                                $scope.addCoursesList = response.data.studentGradPlan.additionalCourses;
                                $scope.addRequirementList = response.data.studentGradPlan.addtionalRequirements;
                                $scope.readyForStudentView = angular.isDefined(response.data.studentGradPlan.readyForStudentView) ? response.data.studentGradPlan.readyForStudentView : false;
                                $scope.gpHeader = {
                                    createDate: response.data.studentGradPlan.createDate,
                                    creditsEarned: response.data.studentGradPlan.creditsEarned,
                                    creditsEarnedNotCounted: response.data.studentGradPlan.creditsEarnedNotCounted,
                                    creditsNeeded: response.data.studentGradPlan.creditsNeeded,
                                    creditsNeededToGraduate: response.data.studentGradPlan.creditsNeededToGraduate,
                                    creditsRequired: response.data.studentGradPlan.creditsRequired,
                                    diplomaId: response.data.studentGradPlan.diplomaId,
                                    diplomaName: response.data.studentGradPlan.diplomaName,
                                    lastModifiedDate: response.data.studentGradPlan.lastModifiedDate,
                                    schoolId: response.data.studentGradPlan.schoolId,
                                    studentGradPlanId: response.data.studentGradPlan.studentGradPlanId,
                                    studentId: response.data.studentGradPlan.studentId,
                                    cteDispName: response.data.studentGradPlan.cteDispName
                                }
                                //Map view summary section
                                $scope.creditSummaryFound = false;
                                if(angular.isDefined(response.data.studentGradPlan.creditsEarned) 
                                		|| angular.isDefined(response.data.studentGradPlan.creditsRequired)
                                		|| angular.isDefined(response.data.studentGradPlan.creditsEarnedNotCounted) 
                                		|| angular.isDefined(response.data.studentGradPlan.creditsNeeded)
                                		|| angular.isDefined(response.data.studentGradPlan.creditsNeededToGraduate)
                                ){
                                	 $scope.creditSummaryFound = true;
                                     $scope.creditsEarned = angular.isDefined(response.data.studentGradPlan.creditsEarned) ? response.data.studentGradPlan.creditsEarned : 0;
                                     $scope.creditsRequired = angular.isDefined(response.data.studentGradPlan.creditsRequired) ? response.data.studentGradPlan.creditsRequired : 0;
                                     $scope.creditsEarnedNotCounted = angular.isDefined(response.data.studentGradPlan.creditsEarnedNotCounted) ? response.data.studentGradPlan.creditsEarnedNotCounted : 0;
                                     $scope.creditsNeeded = angular.isDefined(response.data.studentGradPlan.creditsNeeded) ? response.data.studentGradPlan.creditsNeeded : 0;
                                     $scope.creditsNeededToGraduate = angular.isDefined(response.data.studentGradPlan.creditsNeededToGraduate) ? response.data.studentGradPlan.creditsNeededToGraduate : '';
                                     $scope.percentageCompleted = calculateProgressBar($scope.creditsEarned, $scope.creditsRequired);  
                                }
                                // Get Subjects and update grad plan details
                                if(flag)
                                     $scope.getSchoolSubjects(true);  
                                 else { 
                                        $scope.getSchoolSubjects(false);
                                         flag = false;

                                 }
                                 if($scope.gpHeader.studentGradPlanId )  $scope.getSavedNotes(); //SIS-832
                                 $scope.postHSYearData = { selectedHSPlan: response.data.studentGradPlan.postHsPlansId, text: response.data.studentGradPlan.postHsPlansDetails };
                                 $scope.onChangeHSPlanYear();
                                 $scope.postHSYearDataSnap = {... $scope.postHSYearData};
 
                            }, function(error){
                                console.info('Error in viewing student graduation plan...'.concat(angular.toJson(error)));
                                $scope.isStuGradPlanSpinnerActive = false;

                                $scope.editGradErrorOccurred = true;
                                $scope.editErrorMesg = "";
                                if (error.status == 400) {
                                    $scope.stuGradPlanSuccess = false;
                                    for (var j = 0; j < error.data._errors.length; j++) {
                                        $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }    
                            })
                        }
                        
                        $scope.editStuGradPlan = function(){
                            //create json structure for a updated/newly-added/not-touched row of course, status=1
                            var createCourse = function(gpCourse){
                                return {
                                        id: angular.isDefined(gpCourse.id)? gpCourse.id : null,
                                        courseId: angular.isDefined(gpCourse.course) && gpCourse.course!=null && angular.isDefined(gpCourse.course.id) ? gpCourse.course.id : null,
                                        completionStatusId: gpCourse.completionStatusId,
                                        credits: gpCourse.credits,
                                        creditsEarned: gpCourse.creditsEarned,
                                        doNotIncludeInCreditTotals: gpCourse.doNotIncludeInCreditTotals==null?1:gpCourse.doNotIncludeInCreditTotals,
                                        gradeMark: gpCourse.grade=="Not Started" ? "" : gpCourse.grade,
                                        schoolSubjectId: angular.isDefined(gpCourse.subject) && gpCourse.subject!=null &&angular.isDefined(gpCourse.subject.schoolSubjectId)?gpCourse.subject.schoolSubjectId : null,
                                        k12SubjectId: angular.isDefined(gpCourse.subject) && gpCourse.subject!=null &&angular.isDefined(gpCourse.subject.k12SubjectId) ?gpCourse.subject.k12SubjectId : null,
                                        subjectNotOnDiploma: gpCourse.subjectNotOnDiploma,
                                        gradPlanId: $scope.gpHeader.studentGradPlanId,
                                        status: 1,
                                        isNonK12Course:angular.isDefined(gpCourse.course) && gpCourse.course!=null && angular.isDefined(gpCourse.course.isNonK12Course) && gpCourse.course.isNonK12Course=="Yes"?1:0,
                                        nonK12CourseName:angular.isDefined(gpCourse.course) && gpCourse.course!=null? gpCourse.course.nonK12CourseName : null
                                    };
                            }
                            
                            //create json constructor for term removed, status=0
                            var createTermRemoved = function(yearPlan, term, nYear){
                                if(term.termId!=null){
                                    var nTerm = {};
                                    angular.copy(term, nTerm);
                                    nTerm.courses = undefined;
                                    nTerm.stDbGplanCourseList = [];
                                    nTerm.status = 0;
                                    
                                    angular.forEach(term.courses, function(gpCourse){
                                        if(gpCourse.id!=null){
                                            var nCourse = createCourse(gpCourse);
                                            nCourse.status = 0;
                                            nTerm.stDbGplanCourseList.push(nCourse);
                                        }
                                    });
                                    var courses = $scope.courseRemovedMap['terms/'+yearPlan.index+'/'+term.index];
                                    if(angular.isDefined(courses)){
                                        angular.forEach(courses, function(gpCourse){
                                            if(gpCourse.id!=null){
                                                var nCourse = createCourse(gpCourse);
                                                nCourse.status = 0;
                                                nTerm.stDbGplanCourseList.push(nCourse);
                                            }
                                        });
                                    }
                                    nYear.stdDbGplanTermList.push(nTerm);
                                }
                            }

                            //create json constructor for term newly added/modified, status=1
                            var createTermAdded = function(yearPlan, term, nYear){
                                var nTerm = {};
                                angular.copy(term, nTerm);
                                nTerm.courses = undefined;
                                nTerm.stDbGplanCourseList = [];
                                nTerm.status = 1;
                                    
                                angular.forEach(term.courses, function(gpCourse){
                                    var nCourse = createCourse(gpCourse);
                                    nCourse.status = 1;
                                    nTerm.stDbGplanCourseList.push(nCourse);
                                });
                                var courses = $scope.courseRemovedMap['terms/'+yearPlan.index+'/'+term.index];
                                if(angular.isDefined(courses)){
                                    angular.forEach(courses, function(gpCourse){
                                        if(gpCourse.id!=null){
                                            var nCourse = createCourse(gpCourse);
                                            nCourse.status = 0;
                                            nTerm.stDbGplanCourseList.push(nCourse);
                                        }
                                    });
                                }
                                nYear.stdDbGplanTermList.push(nTerm);
                            }
                            
                        //$scope.courseMovedMap = {};
                            //from terms/addterms/addcourses to terms
                            //key: indices of destination value: indices of source value
                            //value addterms/yearIndex    terms/yearIndex/termIndex addcourses
                        //$scope.termRemovedMap = {};
                            //key: yearIndex
                        //$scope.courseRemovedMap = {};
                            //key: terms/yearIndex/termIndex  addterms/yearIndex    addcourses
                        //$scope.yearRemovedList = [];

                            //create request body to be sent to REST
                            var stuGradPlanEditBody = {};
                            angular.copy($scope.gpHeader, stuGradPlanEditBody);
                            stuGradPlanEditBody.stdDbGplanYearList = [];
                            
                            // $scope.yearPlans = angular.copy($scope.updatedYears);
                           
                            angular.forEach($scope.yearPlans, function(yearPlan){
                                if(($scope.forms.yearPlans['yearPlan_' + yearPlan.index] && $scope.forms.yearPlans['yearPlan_' + yearPlan.index].$dirty) || !$scope.forms.yearPlans['yearPlan_' + yearPlan.index]){
                                    var nYear = {};
                                    angular.copy(yearPlan, nYear);
                                    nYear.terms = undefined;
                                    nYear.schoolYear = yearPlan.schoolYearNum;
                                    nYear.yearName = yearPlan.yearName;
                                    nYear.yearId = nYear.stuPlanYearId;
                                    nYear.stuPlanYearId = null;
                                    if(!$scope.forms.yearPlans['yearPlan_' + yearPlan.index])
                                        nYear.status = 0
                                    else
                                        nYear.status = 1;
                                    nYear.additionalTerms = undefined;

                                    nYear.stdDbGplanTermList = [];
                                    angular.forEach(yearPlan.terms, function(term){
                                        createTermAdded(yearPlan, term, nYear);
                                    });

                                    var termsRemoved = $scope.termRemovedMap[nYear.index];
                                    angular.forEach(termsRemoved, function(term){
                                        createTermRemoved(yearPlan, term, nYear);
                                    });

                                    nYear.additionalTermList = [];
                                    angular.forEach(yearPlan.additionalTerms.courses, function(gpCourse){
                                        var nCourse = createCourse(gpCourse);
                                        nYear.additionalTermList.push(nCourse);
                                    });
                                    //yearPlan.additionalTerms.courses = null;  

                                    var courses = $scope.courseRemovedMap['addterms/'+nYear.index];
                                    if(angular.isDefined(courses)){
                                        angular.forEach(courses, function(gpCourse){
                                            if(gpCourse.id!=null){
                                                var nCourse = createCourse(gpCourse);
                                                nYear.additionalTermList.push(nCourse);
                                            }
                                        });
                                    }
                                    stuGradPlanEditBody.stdDbGplanYearList.push(nYear);             
                                    
                                }
                               
                            });


                            //construct removed year and push to stdDbGplanYearList
                            //check for terms and courses which originally belonged to year, and push it back
                            angular.forEach($scope.yearRemovedList, function(yearPlan){
                                var nYear = {};
                                angular.copy(yearPlan, nYear);
                                nYear.terms = undefined;
                                nYear.schoolYear = yearPlan.schoolYearNum;
                                nYear.yearName = yearPlan.yearName;
                                nYear.yearId = nYear.stuPlanYearId;
                                nYear.stuPlanYearId = null;
                                nYear.status = 0;
                                nYear.additionalTerms = undefined;
                                
                                nYear.stdDbGplanTermList = [];
                                angular.forEach(yearPlan.terms, function(term){
                                    createTermRemoved(yearPlan, term, nYear);
                                });
                                
                                if(angular.isDefined($scope.termRemovedMap[''+nYear.index])){
                                    var terms = $scope.termRemovedMap[''+nYear.index];
                                    angular.forEach(terms, function(term){
                                        createTermRemoved(yearPlan, term, nYear);
                                    });
                                }
                                
                                nYear.additionalTermList = [];
                                angular.forEach(yearPlan.additionalTerms.courses, function(gpCourse){
                                    if(gpCourse.id!=null){
                                        var nCourse = createCourse(gpCourse);
                                        nCourse.status = 0;
                                        nYear.additionalTermList.push(nCourse);
                                    }
                                });
                                
                                var courses = $scope.courseRemovedMap['addterms/'+nYear.index];
                                if(angular.isDefined(courses)){
                                    angular.forEach(courses, function(gpCourse){
                                        if(gpCourse.id!=null){
                                            var nCourse = createCourse(gpCourse);
                                            nCourse.status = 0;
                                            nYear.additionalTermList.push(nCourse);
                                        }
                                    });
                                }
                                stuGradPlanEditBody.stdDbGplanYearList.push(nYear);
                            });
                            
                            stuGradPlanEditBody.additionalCourses = {stdDbGplanTermList: [{stDbGplanCourseList: [], status: 1}], status: 1};
                                
                            angular.forEach($scope.additionalCourseList,  function(addCourse){
                                var nCourse = createCourse(addCourse);  
                                nCourse.gpTermId = addCourse.termId;
                                if($scope.forms.AdditionalCourses.$dirty){
                                    stuGradPlanEditBody.additionalCourses.stdDbGplanTermList[0].stDbGplanCourseList.push(nCourse);
                                    // console.log("modified course", nCourse)
                                }
                            
                                //put deleted courses back to source
                                if(angular.isDefined($scope.courseRemovedMap['addcourses'])){
                                    var courses = $scope.courseRemovedMap['addcourses'];
                                    angular.forEach(courses, function(course){
                                        stuGradPlanEditBody.additionalCourses.stdDbGplanTermList[0].stDbGplanCourseList.push(course);
                                    });
                                }
                            }); 
                            stuGradPlanEditBody.addtionalRequirements = [];
                            angular.forEach($scope.additionalRequirementList,  function(addRequirement){
                             	if($scope.forms.AdditionalRequirements.$dirty){
                             		//console.log('addRequirement',addRequirement);
                             		var addReqRequest ={};
                             		addReqRequest.id=  addRequirement.id;
                             		addReqRequest.comments=  addRequirement.comments;
                             		addReqRequest.required= addRequirement.requiredEdit;
                             		addReqRequest.completionStatusId = addRequirement.completionStatus.id;
                             		stuGradPlanEditBody.addtionalRequirements.push(addReqRequest);
                             	}
                             });
                            
                            if($scope.forms.ReadyForStudentView.$dirty){
                            	stuGradPlanEditBody.readyForStudentView = $scope.readyForStudentViewDisplay.valueEdit;
                            }


                            if($scope.forms.postHSYear && $scope.postHSYearData.selectedHSPlan !== 0){
                              stuGradPlanEditBody.postHsPlansId = $scope.postHSYearData.selectedHSPlan;
                              stuGradPlanEditBody.postHsPlansDetails = $scope.postHSYearData.text;
                            }

                            $scope.isSaveStuPlanBusy = true;
                            $scope.studentRow.entity.editCompleted = false;
                            $scope.savePlanSuccess = false;
                            
                            $http({
                                url: schoolwork12.app.student.endpoints.studentEdit + 'gradplan/' + $scope.gpHeader.studentGradPlanId,  
                                method : "PUT",
                                headers : {
                                    'Content-Type': 'application/json',
                                    'X-API-TOKEN': authentication.getCurrentUser().keycode
                                },
                                data: stuGradPlanEditBody
                            }).then(function(response){
                                $scope.getStudentGradPlan();                    
                                $scope.forms.yearPlans.$setPristine();
                                $scope.forms.AdditionalCourses.$setPristine();
                                $scope.forms.AdditionalRequirements.$setPristine();
                                $scope.forms.ReadyForStudentView.$setPristine();
                                if ($scope.forms.postHSYear)
                                    $scope.forms.postHSYear.$setPristine();
                              //  $scope.forms.Subjects.$setPristine();
                              //  $scope.forms.CoursesNotCounted.$setPristine();

                                $scope.editMode = false;
                                $scope.showSavedStudentMsg = true;
                                $scope.isSaveStuPlanBusy = false;
                                $scope.studentRow.entity.editCompleted = true;
                                $scope.savePlanSuccess = true;
                                
                                $scope.courseMovedMap = {};
                                $scope.termRemovedMap = {};
                                $scope.courseRemovedMap = {};
                                $scope.yearRemovedList = [];
                            }, function(error){
                                console.info('Error in editing graduation plan...'.concat(angular.toJson(error)));
                                $scope.isStuGradPlanSpinnerActive = false;
                                $scope.editGradErrorOccurred = true;
                                $scope.showSavedStudentMsg = false;
                                $scope.isSaveStuPlanBusy = false;
                                $scope.studentRow.entity.editCompleted = false; 

                                $scope.editMode = true;
                                $scope.editErrorMesg = "";
                                if (error.status == 400) {
                                    for (var j = 0; j < error.data._errors.length; j++) {
                                        $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }  
                            })
                        }
                        
                        $scope.saveGradPlanEdit = function(){
                            $scope.toggleMove = false;
                            $scope.toggleSnapshot = false;
                            //validations for grad plan fields
                            if($scope.forms.yearPlans.$dirty){
                                console.log("year plans", $scope.yearPlans)
                                var yearNameSet = [];
                               
                                const alreadySaved = $scope.yearPlans.filter(plan=>plan.stuPlanYearId);
                                const newPlans = $scope.yearPlans.filter(plan=>plan.stuPlanYearId === null);
                                [... alreadySaved, ...newPlans].forEach(plan=>{
                                    if (!$scope.forms.yearPlans['yearPlan_' +plan.index])
                                        return;

                                    if(plan.yearName.trim()==''){
                                        $scope.forms.yearPlans['yearPlan_' +plan.index].$setValidity('yearNameRequired', false);
                                    } else {
                                        $scope.forms.yearPlans['yearPlan_' +plan.index].$setValidity('yearNameRequired', true);

                                    }
                                    
                                    if(angular.isDefined(yearNameSet[plan.yearName.toLowerCase()])){
                                        $scope.forms.yearPlans['yearPlan_' +plan.index].$setValidity('duplicateYearName', false);
                                    } else {
                                        $scope.forms.yearPlans['yearPlan_' +plan.index].$setValidity('duplicateYearName', true);
                                    }
                                    if(plan.yearName.trim()!='')
                                        yearNameSet[plan.yearName.toLowerCase()] = 1 
                                    
                                    var termNameSet = [];
                                    angular.forEach(plan.terms, function(term){
                                        if(term.termName.trim()==''){
                                            $scope.forms.yearPlans['yearPlan_' +plan.index]['termName_'+plan.index+'_'+term.index].$setValidity('termNameRequired', false);
                                        } else {
                                            $scope.forms.yearPlans['yearPlan_' +plan.index]['termName_'+plan.index+'_'+term.index].$setValidity('termNameRequired', true);
                                        }
                                        
                                        if(term.termName.toLowerCase()=='additional term'){
                                            $scope.forms.yearPlans['yearPlan_' +plan.index]['termName_'+plan.index+'_'+term.index].$setValidity('invalidAddTerm', false);
                                        } else {
                                            $scope.forms.yearPlans['yearPlan_' +plan.index]['termName_'+plan.index+'_'+term.index].$setValidity('invalidAddTerm', true);
                                        }
                                        
                                        if(angular.isDefined(termNameSet[term.termName.toLowerCase()])){
                                            $scope.forms.yearPlans['yearPlan_' +plan.index]['termName_'+plan.index+'_'+term.index].$setValidity('duplicateTermName', false);
                                        } else {
                                            $scope.forms.yearPlans['yearPlan_' +plan.index]['termName_'+plan.index+'_'+term.index].$setValidity('duplicateTermName', true);
                                        }
                                        
                                        if(term.termName.trim()!='')
                                            termNameSet[term.termName.toLowerCase()] = 1;
                                        
                                        angular.forEach(term.courses, function(course){ 
                                            if(angular.isDefined(course.subject) && course.subject!=null && course.subject!='' && angular.isDefined(course.subject.name)){
                                                // console.log("check", $scope.forms.yearPlans)
                                                $scope.forms.yearPlans['yearPlan_' +plan.index]['subject_'+plan.index+'_'+term.index+'_'+course.index].$setValidity('subjectRequired', true);
                                            }
                                               
                                            else  {
                                                $scope.forms.yearPlans['yearPlan_' +plan.index]['subject_'+plan.index+'_'+term.index+'_'+course.index].$setValidity('subjectRequired', false);
                                                $scope.forms.yearPlans['yearPlan_' +plan.index].errorExists = true;
                                            }    
                            
                                            if(angular.isDefined(course.credits) && angular.isNumber(course.credits) && course.credits>=0 && course.credits<100)      
                                                $scope.forms.yearPlans['yearPlan_' +plan.index]['credit_'+plan.index+'_'+term.index+'_'+course.index].$setValidity('creditValid', true);
                                            else {
                                                $scope.forms.yearPlans['yearPlan_' +plan.index]['credit_'+plan.index+'_'+term.index+'_'+course.index].$setValidity('creditValid', false);
                                                $scope.forms.yearPlans['yearPlan_' +plan.index].errorExists = true;
                                            }
                                            
                                            if(angular.isDefined(course.course) && course.course!=null && angular.isDefined(course.course.isNonK12Course) && course.course.isNonK12Course =="Yes" && ((!angular.isDefined(course.course.nonK12CourseName)) || (angular.isDefined(course.course.nonK12CourseName) && course.course.nonK12CourseName.trim()==''))) 
                                            	{
                                                $scope.forms.yearPlans['yearPlan_' +plan.index]['nonK12CourseName_'+plan.index+'_'+term.index+'_'+course.index].$setValidity('nonK12CourseNameRequired', false);
                                                $scope.forms.yearPlans['yearPlan_' +plan.index].errorExists = true;
                                            	}
                                            else {
                                                $scope.forms.yearPlans['yearPlan_' +plan.index]['nonK12CourseName_'+plan.index+'_'+term.index+'_'+course.index].$setValidity('nonK12CourseNameRequired', true);
                                            }
                                        });
                                    });

                                    angular.forEach(plan.additionalTerms.courses, function(course){   
                                        if(angular.isDefined(course.subject) && course.subject!=null && course.subject!='' && angular.isDefined(course.subject.name))           
                                            $scope.forms.yearPlans['yearPlan_' +plan.index]['subjectAddTerm_'+plan.index+'_'+course.index].$setValidity('subjectRequired', true);
                                        else {
                                            $scope.forms.yearPlans['yearPlan_' +plan.index]['subjectAddTerm_'+plan.index+'_'+course.index].$setValidity('subjectRequired', false);
                                            
                                        }       
                                    });
                                });
                            }
                            
                            if($scope.forms.AdditionalCourses.$dirty){
                                angular.forEach($scope.additionalCourseList, function(course){
                                    if(angular.isDefined(course.subject) && course.subject!=null && course.subject!='' && angular.isDefined(course.subject.name))             
                                        $scope.forms.AdditionalCourses['subjectAddCourse_'+course.index].$setValidity('subjectRequired', true);
                                    else
                                        $scope.forms.AdditionalCourses['subjectAddCourse_'+course.index].$setValidity('subjectRequired', false);
                                });
                            }
                            
                            //reset forms and check validations
                            resetBeforeSaveValidations();
                            checkFormValidations();
                            $scope.showMovedCoursesMsg = false;
                            
                            if (!$scope.validateYearPlans && !$scope.validateAddCourses && !$scope.validateAddRequirements){
                                //invoke save call once validations are passed
                                $scope.editStuGradPlan();
                            } 
                        }
                
                        $scope.getSchoolSubjects = function(flag){
                             //GET subject list for school
                            var getSubjectsBySchoolPromise = graduationPlanSvc.getSubjectsBySchool(authentication.getCurrentUser().keycode, $scope.studentRow.entity.schoolId, flag);
                            getSubjectsBySchoolPromise.then(function (data) {    
                                console.info("Providing list of related subject"); 
                                $scope.subjectMap = utilService.schoolSubjectMap(data.schoolSubjectList);
                                $scope.courseMap = utilService.schoolCourseMap(data.schoolSubjectList);
                                $scope.subjectFields = data.schoolSubjectList.sort(function(a, b) {
                                    return a.name > b.name ? 1 : -1;
                                });
                                graduationPlanSvc.subjectFields = angular.copy($scope.subjectFields);
                                graduationPlanSvc.mapK12SubjectIds= [];
                                graduationPlanSvc.mapSchoolSubjectIds= [];
                                for(var i=0; i<$scope.subjectFields.length; i++){
                                    
                                        graduationPlanSvc.mapK12SubjectIds[$scope.subjectFields[i].name] = $scope.subjectFields[i].k12SubjectId;
                                        graduationPlanSvc.mapSchoolSubjectIds[$scope.subjectFields[i].name] = $scope.subjectFields[i].schoolSubjectId;
                                }   
                                //invoke and render student grad plan details
                                $scope.getStudentGradPlanDetails();
                                $scope.isEditGradPlanSpinnerActive = false;
                            }, function (error) {
                                console.info('Error in getting subjectlist....'.concat(angular.toJson(error)));   
                                $scope.stuGradPlanSuccess = false;
                                if (error.status == 400) {
                                    for ( var j = 0; j < error.data._errors.length; j++) {
                                        $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }
                            })

                        }
                        
                        //initialising course/term
                        $scope.courseTemplate = {
                            allcourses : [],
                            completionStatusId : 0,
                            course : null,
                            courseName : "Not Specified",
                            credits : 0,
                            grade : "Not Started",
                            index : 0,
                            sequence : 0,
                            showAstrick : true,
                            showDagger : false,
                            status : 1,
                            subject: null,
                            subjectName : '',
                            id : null
                        };
                        $scope.termTemplate = {
                            index: 0,
                            sequence : 0,
                            status: 1,
                            termId: null,
                            termName: '',
                            courses: []
                        }
                        $scope.addSubjectPlan = function(courses){
                            $scope.forms.yearPlans.$setDirty();
                            var lastIndex = -1;
                            var lastSequence = 0;
                            if(courses.length!=0){
                                lastIndex = courses[courses.length-1].index;
                                lastSequence = courses[courses.length-1].sequence;
                            }
                            var newCourse = {status: 1};
                            angular.copy($scope.courseTemplate, newCourse);
                            newCourse.index = lastIndex+1;
                            newCourse.sequence = lastSequence+1;
                            courses.push(newCourse);
                            
                            //console.log($scope.forms.yearPlans);
                            //console.log($scope.yearPlans);
                            //console.log('$scope.courseMovedMap',$scope.courseMovedMap);
                            //console.log('$scope.courseRemovedMap',$scope.courseRemovedMap);
                        }
                        $scope.addTermPlan = function(terms){
                            $scope.forms.yearPlans.$setDirty();
                            var lastIndex = -1;
                            var lastSequence = 0;
                            if(terms.length!=0){
                                lastIndex = terms[terms.length-1].index;
                                lastSequence = terms[terms.length-1].sequence;
                            }
                            var newTerm = {status: 1};
                            angular.copy($scope.termTemplate, newTerm);
                            newTerm.index = lastIndex+1;
                            newTerm.sequence = lastSequence+1;
                            var newCourse = {status: 1};
                            angular.copy($scope.courseTemplate, newCourse);
                            newTerm.courses.push(newCourse);
                            terms.push(newTerm);
                        }
                        $scope.addYearPlan = function(yearPlans){
                            $scope.forms.yearPlans.$setDirty();
                            var lastIndex = -1;
                            var lastSequence = 0;
                            var termNum = 1;
                            var newYearNum = parseInt(moment().format('YYYY'));
                            if(yearPlans.length!=0){
                                lastIndex = yearPlans[yearPlans.length-1].index;
                                termNum = yearPlans[yearPlans.length-1].terms.length;
                                newYearNum = yearPlans[yearPlans.length-1].schoolYearNum+1;
                                lastSequence = yearPlans[yearPlans.length-1].sequence;
                            }
                            
                            var newYear = {
                                schoolYear: "(" + newYearNum + " - " + (newYearNum + 1) + ")",
                                // schoolYear: newYearNum,
                                schoolYearNum: newYearNum,
                                yearName: '',
                                terms: [],
                                index: lastIndex+1,
                                sequence: lastSequence+1,
                                additionalTerms: {courses: []},
                                stuPlanYearId : null,
                                open: true,
                                status: 1
                            };
                            
                            if(lastIndex!=-1){
                                for(var i=0; i<termNum; i++){
                                    var newTerm = {};
                                    angular.copy(yearPlans[yearPlans.length-1].terms[i], newTerm);
                                    newTerm.index = i;
                                    newTerm.sequence = i+1;
                                    newTerm.courses = [];
                                    var newCourse = {};
                                    angular.copy($scope.courseTemplate, newCourse);
                                    newTerm.courses.push(newCourse);
                                    newYear.terms.push(newTerm);
                                }
                            } else {
                                var newTerm = {};
                                angular.copy($scope.termTemplate, newTerm);
                                var newCourse = {};
                                angular.copy($scope.courseTemplate, newCourse);
                                newTerm.courses.push(newCourse);
                                newYear.terms.push(newTerm);
                            }
                            
                            yearPlans.push(newYear);
                            console.log("yearPlans NEXT", yearPlans)
                        }

                        $scope.addPrevYearPlanClicked = false;
                        $scope.addPrevYearPlan = function(yearPlans){
                            $scope.addPrevYearPlanClicked = true;
                            $scope.forms.yearPlans.$setDirty();
                            var lastIndex = -100;
                            var lastSequence = 0;
                            var termNum = 1;
                            var newYearNum = parseInt(moment().format('YYYY'));
                            if(yearPlans.length!=0){
                                lastIndex = yearPlans[0].index;
                                termNum = yearPlans[0].terms.length;
                                newYearNum = yearPlans[0].schoolYearNum-1;
                                lastSequence = lastSequence || yearPlans[0].sequence;

                                console.log("newYearNum INSIDE", newYearNum)
                            }

                            console.log("newYearNum", newYearNum)
                           
                            var newYear = {
                                schoolYear: "(" + newYearNum + " - " + (newYearNum + 1) + ")",
                                schoolYearNum: newYearNum,
                                yearName: '',
                                terms: [],
                                index: newYearNum,
                                sequence: lastSequence+1,
                                additionalTerms: {courses: []},
                                stuPlanYearId : null,
                                open: true,
                                status: 1
                            };

                            console.log("newYear", newYear)
                           
                            if(lastIndex!=-100){ //already yearplans exist
                                for(var i=0; i<termNum; i++){
                                    var newTerm = {};
                                    angular.copy(yearPlans[0].terms[i], newTerm);
                                    newTerm.index = i;
                                    newTerm.sequence = i+1;
                                    newTerm.courses = [];
                                    var newCourse = {};
                                    angular.copy($scope.courseTemplate, newCourse);
                                    newTerm.courses.push(newCourse);
                                    newYear.terms.push(newTerm);
                                }
                            } else { //new year
                                var newTerm = {};
                                angular.copy($scope.termTemplate, newTerm);
                                var newCourse = {};
                                angular.copy($scope.courseTemplate, newCourse);
                                newTerm.courses.push(newCourse);
                                newYear.terms.push(newTerm);
                            }
                           
                            yearPlans.unshift(newYear); //append to the start
                            $scope.prevNewYear = angular.copy(newYear);
                            console.log("yearPlans PREV", yearPlans)
                        }
                        
                        $scope.courseMovedMap = {};
                        //from terms/addterms/addcourses to terms in year
                        //key: indices of destination value: indices of source value
                        //value addterms/yearIndex    terms/yearIndex/termIndex addcourses
                        $scope.termRemovedMap = {};
                        //key: yearIndex/termIndex
                        $scope.courseRemovedMap = {};
                        //key: terms/yearIndex/termIndex  addterms/yearIndex    addcourses
                        $scope.yearRemovedList = [];
                    
                        $scope.removeTerm = function(pIdx, idx){
                            var termRemoved = $scope.yearPlans[pIdx].terms[idx];
                            resetBeforeSaveValidations();
                            checkFormValidations();
                            $scope.showMovedCoursesMsg = false;
                           
                            var openDialogRemoveTerm = function(){
                                $scope.modalInstance2.result.then(function (option) {
                                    if(option){
                                        $scope.yearPlans[pIdx].terms.splice(idx,1);
                                        initializeFormValidations();

                                        if(angular.isDefined($scope.yearPlans[pIdx].stuPlanYearId) && $scope.yearPlans[pIdx].stuPlanYearId!=null 
                                           && angular.isDefined(termRemoved.termId) && termRemoved.termId!=null){
                                            if(angular.isUndefined($scope.termRemovedMap[''+$scope.yearPlans[pIdx].index]))
                                                $scope.termRemovedMap[''+$scope.yearPlans[pIdx].index] = [];
                                            $scope.termRemovedMap[''+$scope.yearPlans[pIdx].index].push(termRemoved);
                                        } else {
                                            angular.forEach(termRemoved.courses, function(course){
                                                if(angular.isDefined(course.id) && course.id!=null){
                                                    var val = $scope.courseMovedMap[$scope.yearPlans[pIdx].index+'/'+termRemoved.index];
                                                    $scope.courseMovedMap[$scope.yearPlans[pIdx].index+'/'+termRemoved.index] = undefined;
                                                    if(angular.isUndefined($scope.courseRemovedMap[val]))
                                                        $scope.courseRemovedMap[val] = [];
                                                    $scope.courseRemovedMap[val].push(course);
                                                }
                                            });
                                        }
                                    }
                                }, function () {
                                });
                            }
                            
                            var withNotStartedCourse = false;
                            if(angular.isDefined(termRemoved.courses) && termRemoved.courses!=null){
                                $scope.forms.yearPlans.$setValidity('removeTermCannotDeleteCourse', true);
                                for(var i=0; i<termRemoved.courses.length; i++){
                                    var courseRemoved = termRemoved.courses[i];
                                    if(courseRemoved.completionStatusId==1 || courseRemoved.completionStatusId==3 || courseRemoved.completionStatusId==4){
                                        $scope.forms.yearPlans.$setValidity('removeTermCannotDeleteCourse', false);
                                        $scope.validateYearPlans = !$scope.forms.yearPlans.$valid ? true : false;
                                        return;
                                    }
                                    
                                    if(courseRemoved.completionStatusId==0){
                                        withNotStartedCourse = true;
                                    }
                                }
                                
                                if(withNotStartedCourse){
                                    $scope.removeTermflag = 1;
                                    $scope.openAlertRemoveTerm();
                                    openDialogRemoveTerm();
                                }
                                
                                if(termRemoved.courses.length==0){
                                    $scope.removeTermflag = 0;
                                    $scope.openAlertRemoveTerm();
                                    openDialogRemoveTerm();
                                }

                            }
                             $scope.forms.yearPlans['yearPlan_'+$scope.yearPlans[pIdx].index].$setDirty();
                        }

                        $scope.removeYear = function(yearRemoved){
                            resetBeforeSaveValidations();
                            checkFormValidations();
                            $scope.forms.yearPlans.$setValidity('cannotDeleteAllYears', true);
                          
                            if(angular.isDefined(yearRemoved.terms) && yearRemoved.terms!=null){
                                for(var i=0; i<yearRemoved.terms.length; i++){
                                    var term = yearRemoved.terms[i];
                                    if(angular.isDefined(term.courses) && term.courses!=null){
                                        $scope.forms.yearPlans.$setValidity('cannotDeleteCompleteOrProgressYear', true);
                                        for(var j=0; j<term.courses.length; j++){
                                            var courseRemoved = term.courses[j];
                                            if(courseRemoved.completionStatusId==1 || courseRemoved.completionStatusId==3 || courseRemoved.completionStatusId==4){
                                                $scope.forms.yearPlans.$setValidity('cannotDeleteCompleteOrProgressYear', false);
                                                console.log("year removing - compl/prog")
                                                $scope.validateYearPlans = !$scope.forms.yearPlans.$valid;
                                                return;
                                            }
                                        }
                                    }
                                }
                            }

                            if($scope.yearPlans.filter(({status})=>status===1).length === 1){
                                $scope.forms.yearPlans.$setValidity('cannotDeleteAllYears', false);
                                $scope.validateYearPlans = !$scope.forms.yearPlans.$valid;
                                return;
                            } 


                            $scope.modalInstance1 = $uibModal.open({
                              animation: $scope.animationsEnabled,
                              templateUrl: 'commonDialog.html',
                              keyboard: false,
                              backdrop: 'static',
                              windowClass: 'alert-Modal',
                              scope: $scope,
                              controller: ['$scope', '$uibModalInstance',
                              ($innerScope, $uibModalInstance) => {
                                $innerScope.ok = () => {
                                    $scope.validateYearPlans = false;
                                    $scope.forms.yearPlans['yearPlan_'+yearRemoved.index].$setDirty();
                                    yearRemoved.status = 0;
                                    $uibModalInstance.close(true);
                                  };
                                  $innerScope.dialogMsg = 'You are about to remove a Year from the student\'s Graduation Plan. This will result in the removal of all associated terms and courses being removed. Do you want to continue?';
                                  $innerScope.cancel = () => {
                                      $uibModalInstance.dismiss('cancel');
                                  };
                              }], 
                              
                          });
                        }
                        
                        //delete course row by clicking delete trash icon
                        $scope.deleteCourse = function(aIdx, pIdx, idx){
                            var courseRemoved = $scope.yearPlans[aIdx].terms[pIdx].courses[idx];

                            resetBeforeSaveValidations();
                            checkFormValidations();
                            $scope.showMovedCoursesMsg = false;

                            if(courseRemoved.completionStatusId==1 || courseRemoved.completionStatusId==3 || courseRemoved.completionStatusId==4){
                                // $scope.forms.yearPlans['yearPlan_'+$scope.yearPlans[aIdx].index]['subject_'+$scope.yearPlans[aIdx].index+'_'+$scope.yearPlans[aIdx].terms[pIdx].index+'_'+$scope.yearPlans[aIdx].terms[pIdx].courses[idx].index].$setValidity('cannotDeleteCompleteOrProgressCourse', false);
                                $scope.forms.yearPlans.$setValidity('cannotDeleteCompleteOrProgressCourse', false);
                                $scope.validateYearPlans = !$scope.forms.yearPlans.$valid ? true : false;
                                return;
                            } else {
                                 $scope.forms.yearPlans.$setValidity('cannotDeleteCompleteOrProgressCourse', true);
                            }
                            $scope.forms.yearPlans['yearPlan_'+$scope.yearPlans[aIdx].index].$setDirty();
                            
                            $scope.yearPlans[aIdx].terms[pIdx].courses.splice(idx,1);
                            if(angular.isDefined(courseRemoved.id) && courseRemoved.id!=null){
                                //var key = 'terms/'+$scope.yearPlans[aIdx].index+'/'+$scope.yearPlans[aIdx].terms[pIdx].index;
                                var key = $scope.yearPlans[aIdx].index+'/'+$scope.yearPlans[aIdx].terms[pIdx].index;
                                if(angular.isDefined[$scope.courseMovedMap[key]]){
                                    var val = $scope.courseMovedMap[key];
                                    $scope.courseMovedMap[key] = undefined; 
                                    if(angular.isUndefined($scope.courseRemovedMap[val]))
                                        $scope.courseRemovedMap[val] = [];
                                    $scope.courseRemovedMap[val].push(courseRemoved);
                                } else {
                                    if(angular.isUndefined($scope.courseRemovedMap['terms/'+key]))
                                        $scope.courseRemovedMap['terms/'+key] = [];
                                    $scope.courseRemovedMap['terms/'+key].push(courseRemoved);
                                }
                            }
                        }
                 

                        //bulk operations: track selected course / term / year
                        $scope.selCourseCount = 0;
                        $scope.selCourses = {};
                        $scope.selectCourse = function(selCourse, yidx, tidx, idx){
                            //$scope.selCourses = {}; //key: terms/yearIndex/termIndex   addterms/yearIndex   addcourses static index
                            //Map<String, List<Course>> selCourses //key: terms/0/1 
                            //yidx undefined --> additional courses
                            //yidx defined tidx undefined --> additional terms
                            //yidx defined tidx defined idx defined --> normal course
                            if(selCourse.coursechecked == true){
                                //yidx undefined --> additional courses exist
                                $scope.selCourseCount = $scope.selCourseCount + 1;
                            } else {
                                $scope.selCourseCount = $scope.selCourseCount - 1;
                            }
                            
                            /*console.log('yidx', yidx);
                            console.log('tidx', tidx);
                            console.log('idx', idx);*/
                        }

                        $scope.subjectsSubmenu = function(subject, sidx){
                            $scope.selectedSubject = subject;
                            $scope.selectedSubjectIdx = sidx;
                            // console.log("subjectsSubmenu", $scope.selectedSubject )
                        }
                        
                        $scope.yearsSubmenu = function(year, yidx){
                            $scope.selectedYear = year;
                            $scope.selectedYearIdx = yidx;
                        }
                        
                        $scope.termClicked = function (term, tidx) {
                            $scope.selectedTerm = term;
                            $scope.selectedTermIdx = tidx;
                        };

                        $scope.closeSnapShot = function(){
                            $scope.toggleSnapshot = !$scope.toggleSnapshot;
                        }

                        $scope.closeIndivSnapShot = function(selSub){
                            // $scope.toggleIndivSnapshot = !$scope.toggleIndivSnapshot;
                            selSub.show = false;
                            $scope.activeCourse=null;
                            $scope.count=0;
                        }

                        $scope.bulkDelete = function(){
                            resetBeforeSaveValidations();
                            checkFormValidations();
                            $scope.showMovedCoursesMsg = false;

                            for(var i=0; i<$scope.yearPlans.length; i++){
                                var plan = $scope.yearPlans[i];
                                for(var j=0; j<plan.terms.length; j++){
                                    var term = plan.terms[j];
                                    for(var k=0; k<term.courses.length; k++){
                                        var course = term.courses[k];
                                        if(course.coursechecked){
                                            if(course.completionStatusId==1 || course.completionStatusId==3 || course.completionStatusId==4){
                                                $scope.forms.yearPlans.$setValidity('cannotDeleteCompleteOrProgressCourse', false);
                                                $scope.validateYearPlans = !$scope.forms.yearPlans.$valid ? true : false;
                                                return;
                                            }
                                        }
                                    }
                                }
                                
                                for(var j=0; j<plan.additionalTerms.courses.length; j++){
                                    var course = plan.additionalTerms.courses[j];
                                    if(course.coursechecked){
                                        if(course.completionStatusId==1 || course.completionStatusId==3 || course.completionStatusId==4){
                                            $scope.forms.yearPlans.$setValidity('cannotDeleteCompleteOrProgressCourse', false);
                                            $scope.validateYearPlans = !$scope.forms.yearPlans.$valid ? true : false;
                                            return;
                                        }
                                    }
                                }
                            }

                            for(var j=0; j<$scope.additionalCourseList.length; j++){
                               var course = $scope.additionalCourseList[j];
                               if(course.coursechecked){
                                   if(course.completionStatusId==1 || course.completionStatusId==3 || course.completionStatusId==4){
                                       $scope.forms.AdditionalCourses.$setValidity('cannotDeleteCompleteOrProgressCourse', false);
                                       $scope.validateAddCourses = !$scope.forms.AdditionalCourses.$valid ? true : false;
                                       return;
                                   }
                               }
                           }

                            $scope.dialogMsg = "You have selected "+$scope.selCourseCount+" course(s) to be deleted from the student's Graduation Plan.  Do you want to continue?";
                            $scope.removeTermflag = -1;
                            $scope.openAlertRemoveTerm();
                            
                            $scope.modalInstance2.result.then(function (option) {
                                if(option){
                                    initializeFormValidations();
                                    for(var i=0; i<$scope.yearPlans.length; i++){
                                        var plan = $scope.yearPlans[i];
                                        for(var j=0; j<plan.terms.length; j++){
                                            var term = plan.terms[j];
                                            for(var k=0; k<term.courses.length; k++){
                                                var course = term.courses[k];
                                                if(course.coursechecked){
                                                    $scope.forms.yearPlans['yearPlan_'+plan.index].$setDirty();
                                                    if(angular.isUndefined($scope.courseRemovedMap['terms/'+plan.index+'/'+term.index]))
                                                        $scope.courseRemovedMap['terms/'+plan.index+'/'+term.index] = [];
                                                    $scope.courseRemovedMap['terms/'+plan.index+'/'+term.index].push(course);
                                                    term.courses.splice(k,1);
                                                    k--;
                                                }
                                            }
                                        }
                                        
                                        for(var j=0; j<plan.additionalTerms.courses.length; j++){
                                            var course = plan.additionalTerms.courses[j];
                                            if(course.coursechecked){
                                                $scope.forms.yearPlans['yearPlan_'+plan.index].$setDirty();
                                                if(angular.isUndefined($scope.courseRemovedMap['addterms/'+plan.index]))
                                                    $scope.courseRemovedMap['addterms/'+plan.index] = [];
                                                $scope.courseRemovedMap['addterms/'+plan.index].push(courseRemoved);

                                                plan.additionalTerms.courses.splice(j,1);
                                                j--;
                                            }
                                        }
                                    }
                                    
                                    for(var i=0; i<$scope.additionalCourseList.length; i++){
                                        var course = $scope.additionalCourseList[i];
                                        if(course.coursechecked){
                                            if(angular.isUndefined($scope.courseRemovedMap['addcourses']))
                                                $scope.courseRemovedMap['addcourses'] = [];
                                            $scope.courseRemovedMap['addcourses'].push(courseRemoved);
                                            
                                            $scope.additionalCourseList.splice(i,1);
                                            i--;
                                        }
                                    }
                                    
                                    $scope.selCourseCount = 0;
                                }
                                
                                // $scope.selectedYear = null;
                                // $scope.selectedYearIdx = -1;
                                // $scope.selectedTerm = null;
                                // $scope.selectedTermIdx = -1;
                            }, function () {
                            });

                        }
                        
                        $scope.toggleMoveFunc = function(){
                            $scope.toggleMove = !$scope.toggleMove;
                        }

                        $scope.toggleSnapshotFunc = function(){
                            var retroPromise= graduationPlanReqNameSvc.getRetroChangeIndicator(authentication.getCurrentUser().keycode, $scope.studentRow.entity.studentId,
                                $scope.gpHeader.studentGradPlanId, $scope.studentRow.entity.schoolId , 1,$scope.dateParams);
                           
                            retroPromise.then(function(response){       
                                $scope.indicator = response;
                                if($scope.indicator > 0){
                                    saveGradPlan(); //open alert modal 
                                 }else    $scope.toggleSnapshot = !$scope.toggleSnapshot;//show snapshot
                            }, function(error){
                                console.info('Error getting Retro Change Indicator...'.concat(angular.toJson(error)));
                                 $scope.editGradErrorOccurred = true;
                                 $scope.editErrorMesg = "";

                                if (error.status == 400) {
                                    for (var j = 0; j < error.data._errors.length; j++) {
                                        $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                                } 
                                
                            });
                                
                                // console.log("$scope.stuGPBySubResponse", $scope.stuGPBySubResponse)
                        }


                        $scope.count=0;
                        $scope.toggleIndivSnapshotFunc = function(selSub, mainInd, parInd, index){

                            var retroPromise= graduationPlanReqNameSvc.getRetroChangeIndicator(authentication.getCurrentUser().keycode, $scope.studentRow.entity.studentId,
                            $scope.gpHeader.studentGradPlanId, $scope.studentRow.entity.schoolId , 1,$scope.dateParams);
                           
                            retroPromise.then(function(response){       
                                $scope.indicator = response;
                                if($scope.indicator > 0){
                                    saveGradPlan(); //open alert modal 
                                }else {   
                                    $scope.activeCourse=selSub;
                                    $scope.selSub = selSub;
                                    selSub.show = true;
                                    $scope.count++;
                                    if($scope.count == 2){
                                        selSub.show = false;
                                        $scope.count=0;
                                    }
                                   
                                    // console.log("selSub - toggleIndivSnapshot", selSub);
                                    // console.log("$scope.stuGPBySubResponse - toggleIndivSnapshot", $scope.stuGPBySubResponse )
                                  
                                    // build subjectsList
                                    $scope.subjectIndivSnapList = [];
                                    angular.forEach($scope.stuGPBySubResponse.subjectsDetails, function(subject){
                                        subject.subjectName = $scope.subjectNameFromMap(subject.schoolSubjectId, subject.k12SubjectId);
                                        // console.log("subject.subjectName", subject.subjectName)
                                        if(angular.isDefined(selSub.subject.k12SubjectId) && selSub.subject.k12SubjectId === subject.k12SubjectId){
                                            selSub.subjectName = subject.subjectName;
                                            selSub.k12SubjectId = subject.k12SubjectId;
                                        } else if(angular.isDefined(selSub.subject.schoolSubjectId) && selSub.subject.schoolSubjectId === subject.schoolSubjectId){
                                            selSub.subjectName = subject.subjectName;
                                            selSub.schoolSubjectId = subject.schoolSubjectId;
                                        } 
                               
                                        if(angular.isDefined(subject.subSubjects)){
                                            angular.forEach(subject.subSubjects, function(subSubject){
                                                subSubject.subjectName = $scope.subjectNameFromMap(subSubject.schoolSubjectId,subSubject.k12SubjectId); 
                                                subSubject.creditsEarned = angular.isDefined(subSubject.creditsEarned) ? subSubject.creditsEarned : 0;
                                                subSubject.creditsRequired = angular.isDefined(subSubject.creditsRequired) ? subSubject.creditsRequired : 0;
                                               
                                                if(angular.isDefined(selSub.subject.k12SubjectId) && selSub.subject.k12SubjectId === subSubject.k12SubjectId){
                                                    selSub.subjectName = subject.subjectName;
                                                    selSub.subSubjectName = subSubject.subjectName;
                                                } else if(angular.isDefined(selSub.subject.schoolSubjectId) && selSub.subject.schoolSubjectId === subSubject.schoolSubjectId){
                                                    selSub.subjectName = subject.subjectName;
                                                    selSub.subSubjectName = subSubject.subjectName;
                                                }
                                                angular.forEach(subSubject.stuGPCourse, function(course){
                                                   course.subjectName = subSubject.subjectName;
                                                   course.subject =   subSubject.schoolSubjectId ;
                                                   course.k12SubjectId = subSubject.k12SubjectId ;
                                                   if(course.isNonK12Course == 1){
                                                       course.courseName = course.nonK12CourseName;
                                                   }
                                                   else{
                                                       course.courseName = $scope.courseDisplay(course); 
                                                   }
                                                   
                                                   course.termName = course.gpTermName;
                                                    if(angular.isDefined(course.schoolYear)){
                                                        //course.schoolSnapYear = angular.copy(course.schoolYear);
                                                        course.schoolSnapYear = course.schoolYear + " - " +  (course.schoolYear + 1);
                                                    }
                                                    else{
                                                       course.schoolSnapYear = angular.isDefined(course.additnlCousDisplaySchoolYear) 
                                                                            ? angular.copy(course.additnlCousDisplaySchoolYear) : "";         
                                                    }
                                                   course.credits = $scope.creditsDisplay(course);
                                                   getGradefromStatus(course);
                                                   course.showDagger = course.doNotIncludeInCreditTotals == 1 || course.subjectNotOnDiploma == 1 ? true : false;
                                                   course.showAstrick = course.completionStatusId == 0 || course.completionStatusId == 1 ? true : false;
                                                });
                                            });
                                        } else {
                                            angular.forEach(subject.stuGPCourse, function(course){
                                                course.subjectName = subject.subjectName;
                                                course.subject =  subject.schoolSubjectId ;
                                                course.k12SubjectId = subject.k12SubjectId ;
                                                if(course.isNonK12Course == 1){ 
                                                    course.courseName = course.nonK12CourseName;
                                                }
                                                else { 
                                                    course.courseName = $scope.courseDisplay(course); 
                                                } 
                                                course.termName = course.gpTermName;
                                                if(angular.isDefined(course.schoolYear)){
                                                     course.schoolSnapYear = angular.copy(course.schoolYear);
                                                }else{
                                                   course.schoolSnapYear = angular.isDefined(course.additnlCousDisplaySchoolYear) 
                                                                        ? angular.copy(course.additnlCousDisplaySchoolYear) : "";        
                                                }
                                                course.credits = $scope.creditsDisplay(course);
                                                getGradefromStatus(course);
                                                course.showDagger = course.doNotIncludeInCreditTotals == 1 || course.subjectNotOnDiploma == 1 ? true : false;
                                                course.showAstrick = course.completionStatusId == 0 || course.completionStatusId == 1 ? true : false;
                                            }); 
                                        } 
                                        $scope.subjectIndivSnapList.push(subject);
                                        
                                      })
                                        //Sort the hierarchial structure for subjectlist
                                        // For each subject in subject list 
                                        angular.forEach($scope.subjectIndivSnapList, function(subject){                            
                                            // If subsubjects are present                           
                                            if(angular.isDefined(subject.subSubjects)){                                
                                                angular.forEach(subject.subSubjects , function(subSubject){
                                                   //sort courses for each sub-subject
                                                   if(angular.isDefined(subSubject.stuGPCourse && subSubject.stuGPCourse.length > 1)){
                                                        subSubject.stuGPCourse.sort(courseSort);    
                                                   } 
                                                });
                                                //sort sub-subjects alphabetically in each subject
                                                subject.subSubjects.sort(sortSubject);
                                            // If no sub-subjects are present and subject has courses                                
                                            } else if(angular.isDefined(subject.stuGPCourse)){
                                                //sort courses in subject
                                                subject.stuGPCourse.sort(courseSort);
                                            }                           
                                        });
                                        // sort list of subjects alphabetically in subject list
                                        // sample using _.js
                                        $scope.subjectIndivSnapList = _.sortBy($scope.subjectIndivSnapList, 'subjectName');
                                }
                            }, function(error){
                                console.info('Error getting Retro Change Indicator...'.concat(angular.toJson(error)));
                                 $scope.editGradErrorOccurred = true;
                                 $scope.editErrorMesg = "";

                                if (error.status == 400) {
                                    for (var j = 0; j < error.data._errors.length; j++) {
                                        $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                                } 
                                
                            });
                        }                

                        
                        $scope.bulkMove = function(){
                            $scope.showMovedCoursesMsg = false;
                            $scope.courseMoved = true;
                            resetBeforeSaveValidations();
                            checkFormValidations();

                            for(var i=0; i<$scope.yearPlans.length; i++){
                                var plan = $scope.yearPlans[i];
                                for(var j=0; j<plan.terms.length; j++){
                                    var term = plan.terms[j];
                                    for(var k=0; k<term.courses.length; k++){
                                        var course = term.courses[k];
                                        if(course.coursechecked){
                                            $scope.forms.yearPlans['yearPlan_'+$scope.yearPlans[$scope.selectedYearIdx].index].$setDirty();
                                                
                                            if(angular.isUndefined($scope.courseMovedMap[plan.index+'/'+term.index])){
                                                $scope.courseMovedMap[$scope.selectedYear.index+'/'+$scope.selectedTerm.index] = 'terms/'+plan.index+'/'+term.index;
                                            } else {
                                                $scope.courseMovedMap[$scope.selectedYear.index+'/'+$scope.selectedTerm.index] = $scope.courseMovedMap[''+plan.index+'/'+term.index];
                                                $scope.courseMovedMap[''+plan.index+'/'+term.index] = undefined;
                                            }

                                            //destionation
                                            var coursesD = $scope.yearPlans[$scope.selectedYearIdx].terms[$scope.selectedTermIdx].courses;
                                            var lastIdx = coursesD.length==0 ? -1 : coursesD[coursesD.length-1].index;
                                            course.index = lastIdx+1;
                                            course.coursechecked = false;
                                            coursesD.push(course);
                                            
                                            term.courses.splice(k,1);
                                            k--;
                                        }
                                    }
                                }

                                for(var j=0; j<plan.additionalTerms.courses.length; j++){
                                    var course = plan.additionalTerms.courses[j];
                                    if(course.coursechecked){
                                        $scope.forms.yearPlans['yearPlan_'+$scope.selectedYearIdx].$setDirty();
                                        $scope.courseMovedMap[$scope.selectedYear.index+'/'+$scope.selectedTerm.index] = 'addterms/'+plan.index;
                                        var coursesD = $scope.yearPlans[$scope.selectedYearIdx].terms[$scope.selectedTermIdx].courses;
                                        var lastIdx = coursesD.length==0 ? -1 : coursesD[coursesD.length-1].index;
                                        course.index = lastIdx+1;
                                        course.coursechecked = false;
                                        coursesD.push(course);

                                        plan.additionalTerms.courses.splice(j,1);
                                        j--;
                                    }
                                }
                            }

                            for(var i=0; i<$scope.additionalCourseList.length; i++){
                                var course = $scope.additionalCourseList[i];
                                if(course.coursechecked){
                                    $scope.forms.yearPlans['yearPlan_'+$scope.selectedYearIdx].$setDirty();
                                    $scope.courseMovedMap[$scope.selectedYear.index+'/'+$scope.selectedTerm.index] = 'addcourses';
                                    var coursesD = $scope.yearPlans[$scope.selectedYearIdx].terms[$scope.selectedTermIdx].courses;
                                    var lastIdx = coursesD.length==0 ? -1 : coursesD[coursesD.length-1].index;
                                    course.index = lastIdx+1;
                                    course.coursechecked = false;
                                    coursesD.push(course);

                                    $scope.additionalCourseList.splice(i,1);
                                    i--;
                                }
                            }
                            
                            // $scope.selectedYear = null;
                            // $scope.selectedYearIdx = -1;
                            // $scope.selectedTerm = null;
                            // $scope.selectedTermIdx = -1;
                            $scope.selCourseCount = 0;
                            $scope.showMovedCoursesMsg = true;
                            $scope.toggleMove = false;

                            resetBeforeSaveValidations();
                            initializeFormValidations();

                        }  
                        
                        $scope.displayText = function(course){
                        	var text = '';
                        	if(course.tranTermType == "Transfer Credit" || course.tranTermType == "Concurrent Enrollment"){
                        		text += course.tranTermType;
                        	}
                        	 
                        	if(course.dualCredit == "1"){
                        		if(text.length > 0){
                        			text += ' and ';
                        		}
                        		text += 'Dual Credit';
                        	}
                        	return text;
                        }
                        $scope.editEnabledCourses = function(course){
                            //enable edit courses for not started
                            if(course.completionStatusId==0)
                                return true;
                            return false;
                        }
                        $scope.showRemoveTermIf = function(term){
                            if(angular.isUndefined(term.courses)){
                                return true;
                            }
                            var len = term.courses.length;
                            if(len==0)
                                return true;
                            for(var i=0; i<len; i++){
                                if(term.courses[i].completionStatusId!=0){
                                    return false;
                                }
                            }
                            return true;
                        }
                        $scope.showRemoveYearIf = function(year){
                            var show = true;
                            if(angular.isDefined(year.additionalTerms)){
                                if(angular.isDefined(year.additionalTerms)&&angular.isDefined(year.additionalTerms.courses)){
                                    for(var i=0; i<year.additionalTerms.courses.length; i++){
                                        var course = year.additionalTerms.courses[i];
                                        if(course.completionStatusId!=0)
                                            return false;
                                    }
                                }
                            }
                            if(angular.isDefined(year.terms)){
                                for(var i=0; i<year.terms.length; i++){
                                    if(angular.isDefined(year.terms[i].courses)){
                                        for(var j=0; j<year.terms[i].courses.length; j++){
                                            var course = year.terms[i].courses[j];
                                            if(course.completionStatusId!=0)
                                                return false;
                                        }
                                    }
                                }
                            }
                            
                            return true;
                        }
                       
                        $scope.disableCourseCredit = function(course,courseName){
                            if(course!=null && angular.isDefined(course.id) && !course.isNonK12Course=="Yes"){
                                return true;
                            }
                            if(course==null || (course!=null && angular.isUndefined(course.id)) || (course!=null && angular.isDefined(course.isNonK12Course) && course.isNonK12Course=="Yes")){
                              return false;
                            }
                            return true;
                        }

                        $scope.credit_focus = function(stuGradCourse){
                            if(stuGradCourse.credits==0){
                                stuGradCourse.credits = '';
                            }
                        }
                       
                        $scope.credit_blur = function(stuGradCourse){
                           if(stuGradCourse.credits=='' || stuGradCourse.credits==null){
                               stuGradCourse.credits = 0;
                           }
                        }

                        $scope.changeCourse = function(stuGradCourse){
                            if(stuGradCourse.completionStatusId == 0){
                               stuGradCourse.credits = stuGradCourse.course!=null ? stuGradCourse.course.credits : 0;  
                            }
                            if(angular.isDefined(stuGradCourse.course) && stuGradCourse.course!=null && angular.isDefined(stuGradCourse.course.isNonK12Course) && stuGradCourse.course.isNonK12Course=="Yes")
                            	{
                            	stuGradCourse.course.nonK12CourseName = "";
                            	}
                        }

                        $scope.changeSubject = function(stuGradCourse){
                             console.log("stuGradCourse", stuGradCourse)
                             stuGradCourse.subChanged = true;
                             stuGradCourse.isOnDiplomaFlag = false;
                             angular.forEach($scope.stuGPBySubResponse.subjectsDetails, function(subject){
                                // console.log("subject", subject);

                                if(angular.isDefined(subject.is_onDiploma) && (subject.is_onDiploma == 1)){
                                    if(stuGradCourse.subject.name == subject.subjectName){
                                        // console.log("subject is_onDiploma", subject);
                                        stuGradCourse.isOnDiplomaFlag = true;
                                    }

                                    if(angular.isDefined(subject.subSubjects)){
                                        angular.forEach(subject.subSubjects, function(subSubject){
                                            if(stuGradCourse.subject.name == subSubject.subjectName){
                                                // console.log("subSubject is_onDiploma", subject);
                                                stuGradCourse.isOnDiplomaFlag = true;
                                            }
                                        })
                                    }

                                }     
                                
                             })
                            console.log("stuGradCourse.isOnDiplomaFlag", stuGradCourse.isOnDiplomaFlag);
                            stuGradCourse.show = false;
                            //fetch preselected course and populate allcourses
                            var preCourse = stuGradCourse.course;
                            var nonK12Course =  {id: null,  name: "Non K12 Course", credits:0, nonK12CourseName: "", isNonK12Course:"Yes"};
                            stuGradCourse.allcourses = [];
                            if(stuGradCourse.subject!=null && angular.isDefined(stuGradCourse.subject.courses)){
                                angular.extend(stuGradCourse.allcourses, stuGradCourse.subject.courses);
                                stuGradCourse.allcourses.sort(sortCourseName);
                            }
                            //get courseFromMap for preCourse
                            var courseMatch = null;
                            if(angular.isDefined(stuGradCourse.subject) && stuGradCourse.subject!=null
                              && (preCourse!=null && angular.isDefined(preCourse.id)))
                               courseMatch = courseFromMap(stuGradCourse.subject.schoolSubjectId, stuGradCourse.subject.k12SubjectId, preCourse.id);
                            if(courseMatch!=null && angular.isDefined(courseMatch.id)){
                                stuGradCourse.course = courseMatch;
                                stuGradCourse.allcourses.sort(sortCourseName);
                                return;
                            }
                            if(preCourse!=null && angular.isDefined(preCourse.id))
                            	{
                                stuGradCourse.allcourses.push(preCourse);
                                stuGradCourse.allcourses.sort(sortCourseName);
                            	}
                            if(preCourse!=null && angular.isUndefined(preCourse.id) && angular.isDefined(preCourse.isNonK12Course) && preCourse.isNonK12Course=="Yes")
                            { 
                            	stuGradCourse.allcourses.push(preCourse);
                            	stuGradCourse.course = preCourse;
                            }
                            if(!hasNonK12Course(stuGradCourse.allcourses))
                        	{
                            	stuGradCourse.allcourses.push(nonK12Course);
                        	}
                            
                            //console.log("courses", stuGradCourse);
                        }
                        
                        var hasNonK12Course = function(courses)
                        {
                        	for (var i = 0; i < courses.length; i++) 
                        	{
                        	    if(courses[i].name == "Non K12 Course" && courses[i].isNonK12Course =="Yes")
                        	    	{
                        	    	return true;
                        	    	}
                        	}
                        	return false;
                        }
                        
                        $scope.subjectNameFromMap = function(schoolSubjectId,k12SubjectId){
                        	var schSubjectId = angular.isDefined(schoolSubjectId) ? "schSubjectId"+schoolSubjectId : null;
                            var k12SubjectId = angular.isDefined(k12SubjectId) ? "k12SubjectId"+k12SubjectId : null;
                            var subjectName = "";
                            if(angular.isDefined($scope.subjectMap[schSubjectId])){
                                subjectName = $scope.subjectMap[schSubjectId].name;
                            }
                            if(angular.isDefined($scope.subjectMap[k12SubjectId])){
                                subjectName = $scope.subjectMap[k12SubjectId].name;
                            }
                            return subjectName;
                        }
                        var subjectFromMap = function(schoolSubjectId,k12SubjectId){
                        	var schSubjectId = angular.isDefined(schoolSubjectId) ? "schSubjectId"+schoolSubjectId : null;
                            var k12SubjectId = angular.isDefined(k12SubjectId) ? "k12SubjectId"+k12SubjectId : null;
                            var subject = {};
                            if(angular.isDefined($scope.subjectMap[schSubjectId])){
                                subject = $scope.subjectMap[schSubjectId];
                            }
                            if(angular.isDefined($scope.subjectMap[k12SubjectId])){
                                subject = $scope.subjectMap[k12SubjectId];
                            }
                            return subject;
                        }

                        var courseFromMap = function(schoolSubjectId,k12SubjectId,courseId){
                        	var schSubjectId = angular.isDefined(schoolSubjectId) ? "schSubjectId"+schoolSubjectId : "";
                            var k12SubjectId = angular.isDefined(k12SubjectId) ? "k12SubjectId"+k12SubjectId : "";
                            var courseId = angular.isDefined(courseId) ? "courseId"+courseId : "";
                            var course = {};
                            
                            if(angular.isDefined($scope.courseMap[schSubjectId+courseId])){
                                course = $scope.courseMap[schSubjectId+courseId];
                            }	
                            if(angular.isDefined($scope.courseMap[k12SubjectId+courseId])){
                                course = $scope.courseMap[k12SubjectId+courseId];
                            }
                            return course;
                        }
                        $scope.courseDisplay = function(course){
                        	var courseText = "";
                        	 if((course.completionStatusId == 3 || course.completionStatusId == 4) && angular.isDefined(course.tranCourseName)){
                        		 courseText = course.tranCourseName;
	                          }else{
	                        	  courseText = angular.isDefined(course.courseName) ? course.courseName : "Not Specified";
	                         }
                        	 return courseText;
                        }
                        $scope.creditsDisplay = function(course){
                        	var creditText = "";
                        	if(course.completionStatusId == 3 || course.completionStatusId == 4){
                        		creditText = course.creditsEarned;
	  	                    }else{
	  	                    	creditText = course.credits;
	  	                    }
	  	                    return creditText;
                        }
                        var calculateProgressBar = function (creditsEarned, creditsRequired){
                        	var percentCompleted = ((creditsEarned/creditsRequired) * 100).toFixed(0);	    					
                        	if(isNaN(percentCompleted) || (percentCompleted < 1)){
                        		return 0;
                        	}else if(percentCompleted > 100 ){
        						return 100;
        					}else{
        						return percentCompleted;
        					}
                        }
                        
                        //allow user to procced for delete course action
                        var resetBeforeSaveValidations = function(){
                            $scope.forms.yearPlans.$setValidity('cannotDeleteCompleteOrProgressCourse', true);
                            $scope.forms.yearPlans.$setValidity('removeTermCannotDeleteCourse', true);
                            $scope.forms.yearPlans.$setValidity('cannotDeleteAllYears', true);
                            $scope.forms.yearPlans.$setValidity('cannotDeleteCompleteOrProgressYear', true);
                            $scope.forms.AdditionalCourses.$setValidity('cannotDeleteCompleteOrProgressCourse', true);
                        };

                        var initializeFormValidations = function(){
                            $scope.validateYearPlans = false;
                            $scope.validateAddCourses = false;
                            $scope.validateAddRequirements = false;
                        }

                        var checkFormValidations = function(){
                            //add error styles based on validation flags
                            $scope.validateYearPlans = !$scope.forms.yearPlans.$valid ? true : false;
                            $scope.validateAddCourses = !$scope.forms.AdditionalCourses.$valid ? true : false;
                            $scope.validateAddRequirements = !$scope.forms.AdditionalRequirements.$valid ? true : false;
                        }

                        $scope.isSaveEnabled = function () {
                            if($scope.forms.yearPlans){
                                if($scope.forms.yearPlans.$dirty || $scope.forms.AdditionalCourses.$dirty || 
                                    (angular.isDefined($scope.forms.AdditionalRequirements) && $scope.forms.AdditionalRequirements.$dirty)
                                    ||  (angular.isDefined($scope.forms.ReadyForStudentView) && $scope.forms.ReadyForStudentView.$dirty)
                                    ||  ($scope.forms.postHSYear && $scope.forms.postHSYear.$dirty)) {
                                    return true;
                                } 
                            }
                        	return false;
                        }
                       var additionalReqStatusMap = function(){
                        	return [{id: 0, label: 'Not Started'},{id: 1, label: 'In Progress'},{id: 2, label: 'Completed'}];
                       }
                       var additionalReqValueFromMap = function(key){
                        	return (angular.isDefined($scope.addReqStatusMap[key])) ? $scope.addReqStatusMap[key]: 0;
                       }

                       $scope.printGradPlan = function() {
                            window.print();
                       }

                       $scope.getPostHSPlaceholder = (name) => {
                        if(name.startsWith('Education')){
                            return  'List college/university/certificate degree program'
                        }
                        if(name.startsWith('Employment')){
                            return  'List career/job plans; internship; apprenticeship'
                        }
                        if(name.startsWith('Enlistment')){
                            return 'List military branch/military occupation'
                        }
                        return "";
                       }

                       $scope.onChangeHSPlanYear = (shouldUpdatePlaceholderStatus) =>{
                        const selectedPlan = $scope.HSPlanList.find(plan=>plan.id === $scope.postHSYearData.selectedHSPlan);
                        const name = selectedPlan? selectedPlan.name : '';
                        $scope.postHSYearData.HSPlaceholder = $scope.getPostHSPlaceholder(name);
                        
                        if(shouldUpdatePlaceholderStatus)
                            $scope.changesHsPlaceholderYear();
                       };

                       $scope.HSPlanList = []
                       graduationPlanReqNameSvc.getPostHS(authentication.getCurrentUser().keycode).then((data)=>{
                            $scope.HSPlanList = data.slice(1);
                            $scope.HSPlanList.sort((a,b)=>a.name.localeCompare(b.name));
                       });

                       $scope.changesHsPlaceholderYear = () =>{
                        if ($scope.forms.postHSYear)
                            $scope.forms.postHSYear.$setDirty();
                       }
            }
        ]);   
}(angular, schoolwork12));
